// src/app/reference/reference.component.ts
import {
  Component,
  ViewChild,
  OnInit,
  ElementRef,
  viewChild,
  HostListener,
  NgZone,
} from "@angular/core";
import { ChangeDetectorRef } from "@angular/core";
import { AzureOpenaiService } from "../azure-openai.service";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SidebarComponent } from "../sidebar/sidebar.component";
import moment from "moment-timezone";
import { CitationComponent } from "../citation/citation.component";
import { GoogleGenerativeAI } from "@google/generative-ai";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

import mammoth from "mammoth";
import { AppInsightsService } from "../app-insights.service";
import { FeedbackPopupComponent } from "../feedback-popup/feedback-popup.component";
import { v4 as uuidv4 } from "uuid";
import { HttpClient } from "@angular/common/http";
import { GeminiService } from "../services/gemini.service";
import { ImageGenerationService } from "../services/image-generation.service";
import { environment } from "../../environments/environment";
import { MsalService } from "@azure/msal-angular";
import { MessageService } from "../services/message.service";
import { FontSizeService } from "../services/font-size.service";

// import { ChatSessionService } from '../chat-session.service';
// src/app/reference/reference.component.ts
import {
  ChatSessionService,
  ChatSession,
  ChatMessage,
} from "../chat-session.service";
import { MarkdownModule } from 'ngx-markdown';
import { DecodeHtmlEntitiesPipe } from "../pipes/decode-html-entities.pipe";
import JSZip from "jszip";
import { forkJoin, of } from "rxjs";
import { catchError } from "rxjs/operators";

@Component({
    selector: "app-reference",
    imports: [
        SidebarComponent,
        CitationComponent,
        FeedbackPopupComponent,
        CommonModule,
        FormsModule,
        MarkdownModule,
        DecodeHtmlEntitiesPipe,
    ],
    templateUrl: "./reference.component.html",
    styleUrl: "./reference.component.scss"
})
export class ReferenceComponent implements OnInit {
  userPrompt = "";
  chatHistory: ChatMessage[] = []; // Initialize with proper type
  isLoading = false;
  isSidebarHidden: boolean = false;
  isSearchEnabled = false;
  isChangelogOpen: boolean = false;
  sidebarWidth: number = Math.floor(window.innerWidth * 0.15); // 15% of viewport
  private requestStartTime: number = 0;
  copiedMessageIndex: any = null;

  // Voice input properties
  isRecording: boolean = false;
  private recognition: any = null;
  private speechRecognitionSupported: boolean = false;

  // Changelog version tracking
  private readonly CHANGELOG_VERSION = "2025-11-14"; // Update this date when you add new changes
  get minSidebarWidth(): number {
    return Math.floor(window.innerWidth * 0.15);
  }
  get maxSidebarWidth(): number {
    return Math.floor(window.innerWidth * 0.30);
  }
  mainContentWidth: number = 0;

  // Mobile sidebar properties
  isMobileSidebarActive: boolean = false;
  isMobileView: boolean = false;

  private isDragging: boolean = false;
  private initialMouseX: number = 0;
  private initialSidebarWidth: number = 0;
  @ViewChild("appContainer", { static: true }) appContainer!: ElementRef;
  @ViewChild("sideContainer", { static: false })
  sideContainer!: SidebarComponent;
  // @viewChild('SidebarComponentRef', { static: false }) sidebarComponent: SidebarComponent;

  chatSessions: ChatSession[] = [];
  currentSessionId: string | null = null;
  currentSessionName: string = "New Chat";

  isSidebarHidden2: boolean = false;
  citations: any;
  citations_count: number = 0;
  showComponent: boolean = false;
  selectedContent: string = "";
  base64ImageString: string = "";
  selectedFileType: string = "";
  models = [
    // { slug: "gpt4-o", name: "GPT-4o" },
    // { slug: "gpt-4o-mini", name: "GPT-4o-Mini" },
    { slug: "gpt-4.1", name: "GPT-4.1" },
    // { slug: 'gpt-5', name: 'GPT-5' },
    { slug: "gpt-5-mini", name: "GPT-5 Mini" },
    { slug: "gemini-2.5-flash", name: "Gemini 2.5 Flash" },
    { slug: "gemini-2.5-pro", name: "Gemini 2.5 Pro" },
    { slug: "gemini-3.5-flash", name: "Gemini 3.5 Flash" },
    { slug: "gemini-3.1-pro-preview", name: "Gemini 3.1 Pro" },
    { slug: "gpt-image-1-mini", name: "GPT Image Mini (Image)", isImageModel: true },
    { slug: "gemini-2.5-flash-image", name: "Nano Banana", isImageModel: true },
  ];
  temperature = [
    { slug: 1.0, name: "high" },
    { slug: 0.5, name: "medium" },
    { slug: 0.0, name: "low" },
  ];
  reasoningLevels = [
    { slug: "high", name: "high" },
    { slug: "medium", name: "medium" },
    { slug: "low", name: "low" },
  ];
  selectdModel = "gpt-4.1";
  selectdTemperature = 0.5;
  selectedReasoning: string = "medium";
  gemini_max_token = 1048576;
  gpt_max_token = 128000;
  total_used_token = 0;
  balanced_token = 1048576;

  // Check if current session's model is available in dropdown
  get isCurrentSessionModelAvailable(): boolean {
    if (!this.currentSessionId || !this.selectdModel) {
      return true; // No session or new chat - allow input
    }
    // Check if selectdModel exists in the models array
    return this.models.some(model => model.slug === this.selectdModel);
  }

  // Cumulative token tracking for conversation
  private conversationTokens = 0;
  private sessionTokenHistory: { [sessionId: string]: number } = {};

  // Decreasing token limit simulation
  private remainingTokens = 0;
  private sessionRemainingTokens: { [sessionId: string]: number } = {};
  private initialTokenLimit = 0;

  MAX_SIZE_MB = {
    gemini: 7,
    azure: 10,
  };

  inputText: string = "";
  maxCharacters = 12000;
  zoomLevel: number = 1.0;
  isTokenLimitExceeded = false;
  isWebSearchEnabled: boolean = false;
  @ViewChild("chatContainer") private chatContainer!: ElementRef;

  // Image generation properties
  imageSize: string = '1024x1024';
  imageQuality: string = 'standard';
  imageStyle: string = 'vivid';
  
  // Size options for different image models
  dalleSizes = [
    { value: '1024x1024', label: 'Square (1024×1024)' },
    { value: '1792x1024', label: 'Landscape (1792×1024)' },
    { value: '1024x1792', label: 'Portrait (1024×1792)' }
  ];
  
  gptImageSizes = [
    { value: '1024x1024', label: 'Square (1024×1024)' },
    { value: '1536x1024', label: 'Landscape (1536×1024)' },
    { value: '1024x1536', label: 'Portrait (1024×1536)' }
  ];
  
  // Dynamic size options based on selected model
  get imageSizes() {
    if (this.selectdModel === 'gpt-image-1-mini') return this.gptImageSizes;
    if (this.selectdModel === 'gemini-2.5-flash-image') return this.dalleSizes;
    return this.dalleSizes;
  }
  
  imageQualities = [
    { value: 'standard', label: 'Standard' },
    { value: 'hd', label: 'HD' }
  ];
  
  imageStyles = [
    { value: 'vivid', label: 'Vivid' },
    { value: 'natural', label: 'Natural' }
  ];

  // Check if any image generation model is selected
  get isImageModelSelected(): boolean {
    return this.selectdModel === 'dall-e-3' || this.selectdModel === 'gpt-image-1-mini' || this.selectdModel === 'gemini-2.5-flash-image';
  }
  
  // Check if DALL-E is selected (for backward compatibility)
  get isDallESelected(): boolean {
    return this.isImageModelSelected;
  }

  @ViewChild("userInput") userInputField: any;
  @ViewChild("myTextArea") myTextArea: any;

  // Smart scroll properties
  private shouldAutoScroll: boolean = true;
  private isUserScrolling: boolean = false;
  private scrollThreshold: number = 100; // pixels from bottom to consider "at bottom"
  // Gemini API calls now go through backend via GeminiService - no API key in frontend
  systemPrompt =
    "When a user asks a new question, respond only to that specific query. If the user's question references their previous messages, incorporate those earlier messages into the answer. Otherwise, respond based solely on the most recent query. If the user asks multiple questions in one message, answer them separately and clearly. Ensure responses are accurate and up to date, especially when retrieving real-time information.";
  response: any;
  selectedFiles: any[] = [];
  isPopoverOpen = false;
  newChatName: string = "New Chat";
  private isStartingNewChat: boolean = false;
  private hasInitialSessionBeenSet: boolean = false;
  private initialPromptBeforeRecording: string = "";

  // User profile properties for header
  userDisplayName: string | null = null;
  userDisplayEmail: string | null = null;
  userProfilePicture: string | null = null;
  isUserDropdownOpen: boolean = false;
  isNotificationDropdownOpen: boolean = false;

  // ---- Export chats as ZIP ----
  isExportModalOpen: boolean = false;
  isExporting: boolean = false;
  exportSelectedIds: Set<string> = new Set<string>();
  exportSortOrder: 'desc' | 'asc' = 'desc'; // desc = newest first
  exportStartDate: string = ''; // yyyy-MM-dd
  exportEndDate: string = '';   // yyyy-MM-dd
  isFontSizeDropdownOpen: boolean = false;
  hasUnreadNotification: boolean = false;

  // Update this version string whenever you update the notification content
  private readonly NOTIFICATION_VERSION = '2026-02-12';
  
  get userInitials(): string {
    if (this.userDisplayName) {
      const names = this.userDisplayName.split(' ');
      if (names.length >= 2) {
        // Format: Last, First (e.g., "Spence, Alex" → "AS")
        return (names[names.length - 1][0] + names[0][0]).toUpperCase();
      }
      return this.userDisplayName.substring(0, 2).toUpperCase();
    }
    if (this.userDisplayEmail) {
      return this.userDisplayEmail.substring(0, 2).toUpperCase();
    }
    return 'U';
  }

  constructor(
    private http: HttpClient,
    private azureOpenAiService: AzureOpenaiService,
    private appInsightsService: AppInsightsService,
    private el: ElementRef,
    private chatSessionService: ChatSessionService,
    private zone: NgZone,
    private cdr: ChangeDetectorRef,
    private geminiService: GeminiService,
    private imageGenerationService: ImageGenerationService,
    private msalService: MsalService,
    private messageService: MessageService,
    public fontSizeService: FontSizeService
  ) {
    this.appInsightsService.trackUser();
    // All Gemini API calls now go through backend via GeminiService
    // API key is stored server-side only - never exposed to frontend
  }
  ngOnInit(): void {
    // Step 1: Ensure userId exists in localStorage
    let userId = localStorage.getItem("userId");
    if (!userId) {
      userId = uuidv4();
      localStorage.setItem("userId", userId);
      console.log("Generated and stored new userId:", userId);
    }

    // Step 1.5: Initialize user profile for header
    this.initializeUserProfile();

    // Step 1.6: Check if user has seen the latest notification
    this.checkNotificationStatus();

    // Step 2: Set layout
    this.calculateMainContentWidth();

    // Step 2.1: Check if mobile view and setup responsive behavior
    this.checkMobileView();
    this.setupResizeListener();

    // Step 2.5: Set default web search state based on model
    this.updateWebSearchState();

    // Step 2.6: Load saved zoom level
    this.loadSavedZoomLevel();

    // Step 2.7: Initialize speech recognition
    this.initializeSpeechRecognition();

    // Step 3: Fetch sessions from backend
    this.chatSessionService.fetchUserSessionsAndSet(userId);

    // Step 4: Subscribe to all sessions (UI update)
    this.chatSessionService.allSessions$.subscribe((sessions) => {
      this.chatSessions = sessions;
      console.log(
        "Received updated sessions:",
        sessions.length,
        "isStartingNewChat:",
        this.isStartingNewChat
      );

      this.hasInitialSessionBeenSet = true;
      this.cdr.detectChanges();
    });

    // Step 5: Subscribe to current session updates
    this.chatSessionService.currentSession$.subscribe((session) => {
      console.log(
        " Current session changed:",
        session ? session.name : "null",
        "isStartingNewChat:",
        this.isStartingNewChat
      );

      // If a valid session is set, we are no longer starting a new chat
      if (session !== null) {
        this.isStartingNewChat = false;
      }

      // COMPLETELY BLOCK session updates when starting new chat
      if (this.isStartingNewChat) {
        console.log(" BLOCKING session update - user is starting new chat");
        return;
      }

      if (!session) {
        // No session - clear current state and wait for user interaction
        console.log("No session - clearing UI state");
        this.currentSessionId = null;
        this.currentSessionName = "New Chat";
        this.chatHistory = [];
        // Reset tokens for new session
        this.conversationTokens = 0;
        this.initialTokenLimit = this.selectdModel.startsWith("gemini")
          ? this.gemini_max_token
          : this.gpt_max_token;
        this.remainingTokens = this.initialTokenLimit;
        this.total_used_token = 0;
        this.balanced_token = this.remainingTokens;
        this.isTokenLimitExceeded = false;
        this.cdr.detectChanges();
        return;
      }

      console.log(" Setting session in UI:", session.name);

      this.currentSessionId = session.id;
      this.currentSessionName = this.sanitizeTitle(session.name);
      this.chatHistory = this.normalizeHistory(session.history);

      this.selectdModel = session.model || this.selectdModel;
      this.selectdTemperature = session.temperature || this.selectdTemperature;

      // Restore cumulative token count for this session
      this.restoreSessionTokens(session.id);
      this.isTokenLimitExceeded = false;

      // Sync previous selections to avoid false popups on non-model changes
      this.previousModel = this.selectdModel;
      this.previousTemperature = this.selectdTemperature;
      this.previousReasoning = this.selectedReasoning;
      // Scroll to the start of the last message when a session is loaded
      // Use longer timeout to allow all markdown components to render
      this.cdr.detectChanges();
      setTimeout(() => {
        this.cdr.detectChanges();
        this.scrollToStartOfLastAssistantMessage();
        this.focusTextArea();
      }, 200);
      // Safety: ensure rendering completes for very long conversations
      setTimeout(() => {
        this.cdr.detectChanges();
      }, 500);
    });

    // Step 6: Check if changelog should auto-open
    this.checkChangelogVersion();

    // Step 7: Setup smart scroll behavior
    this.setupScrollListener();
  }

  loadChatSessions(): void {
    const sessionsFromStorage = sessionStorage.getItem("chatSessions");
    if (sessionsFromStorage) {
      try {
        this.chatSessions = JSON.parse(sessionsFromStorage);
        if (Array.isArray(this.chatSessions)) {
          this.chatSessions.sort(
            (a, b) =>
              new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
          );
        } else {
          this.chatSessions = [];
        }
        this.initializeSessionAfterLoad();
      } catch (error) {
        console.error("Error parsing sessions from storage:", error);
        this.chatSessions = [];
      }
    }

    // Fetch from the API to get the most up-to-date sessions
    // Ensure the userId is appended to the GET request for user-specific sessions
    const sessionId = localStorage.getItem("sessionId");
    const apiGetUrl = `${environment.apiBaseUrl}/sessions/${sessionId}`;
  }

  private initializeSessionAfterLoad(): void {
    // Don't automatically create sessions - let the service handle this
    // The service will create sessions when needed, and this component will receive them via subscription
    console.log(
      "initializeSessionAfterLoad: Waiting for sessions from service"
    );
  }

  handleSessionLoaded(sessionId: string): void {
    if (this.currentSessionId) {
      const currentSession = this.chatSessions.find(
        (s) => s.id === this.currentSessionId
      );
      if (currentSession && currentSession.history.length > 0) {
        this.saveCurrentSession();
      } else if (
        currentSession &&
        currentSession.history.length === 0 &&
        this.currentSessionId !== sessionId
      ) {
        this.chatSessions = this.chatSessions.filter(
          (s) => s.id !== this.currentSessionId
        );
        this.saveChatSessions();
      }
    }

    const session = this.chatSessions.find((s) => s.id === sessionId);
    if (session) {
      this.currentSessionId = session.id;
      this.chatHistory = this.normalizeHistory(session.history);
      this.userPrompt = "";
      this.selectedFiles = [];
      this.currentSessionName = this.sanitizeTitle(session.name);
      this.selectdModel = session.model || this.selectdModel;
      this.selectdTemperature = session.temperature || this.selectdTemperature;

      if (this.selectdModel.startsWith("gemini")) {
        this.balanced_token = this.gemini_max_token;
      } else {
        this.balanced_token = this.gpt_max_token;
      }
      // Token count managed by cumulative tracking system
      this.isTokenLimitExceeded = false;
    } else {
      // Don't automatically create a new session - let the service handle this
      console.log("Session not found, waiting for service to provide sessions");
    }
  }

  handleSessionShared(sessionId: string): void {
    this.messageService.showSuccess(
      "Share Session",
      `Share functionality for session ${sessionId} initiated from ReferenceComponent.`
    );
  }

  // The backend persists message `file`/`references` as JSON strings (e.g. "[]"),
  // not arrays. A truthy string slips past `value || []` checks and then breaks
  // both `.map()` (TypeError) and *ngFor (NG02200). Coerce to a real array here.
  private toArrayField(value: any): any[] {
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) return [];
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  }

  private normalizeHistory(history: any[]): ChatMessage[] {
    return (history || []).map((msg: any) => ({
      ...msg,
      content: this.decodeHtmlEntities(msg.content),
      file: this.toArrayField(msg.file),
      references: this.toArrayField(msg.references),
    }));
  }

  updateCurrentSessionHistory(): void {
    if (this.currentSessionId) {
      const sessionIndex = this.chatSessions.findIndex(
        (s) => s.id === this.currentSessionId
      );
      if (sessionIndex !== -1) {
        this.chatSessions[sessionIndex].history = [...this.chatHistory];
        this.chatSessions[sessionIndex].timestamp = moment()
          .tz("America/New_York")
          .format();
        if (
          this.chatSessions[sessionIndex].name === "New Chat" &&
          this.chatHistory.length > 0
        ) {
          const firstUserPrompt = this.chatHistory[0].content;
          // Strip surrounding quotes if present (handles ", ', and smart quotes)
          const sanitizedFirstPrompt = (firstUserPrompt || "").replace(/^["'“”]+|["'“”]+$/g, "");
          const generatedName =
            sanitizedFirstPrompt.substring(0, 30) +
            (sanitizedFirstPrompt.length > 30 ? "..." : "");
          this.chatSessions[sessionIndex].name = generatedName;
          (this.chatSessions[sessionIndex] as any).title = generatedName;
        }
        this.saveChatSessions();
      }
    }
  }

  togglePopover() {
    this.isPopoverOpen = !this.isPopoverOpen;
  }

  toggleChangelog() {
    this.isChangelogOpen = !this.isChangelogOpen;

    // Mark changelog as seen when user closes it
    if (!this.isChangelogOpen) {
      this.markChangelogAsSeen();
    }
  }

  /**
   * Check if the current changelog version has been seen
   * Auto-opens changelog if it's a new version
   */
  private checkChangelogVersion(): void {
    const lastSeenVersion = localStorage.getItem("changelogLastSeen");

    // If user hasn't seen this version, auto-open the changelog
    if (lastSeenVersion !== this.CHANGELOG_VERSION) {
      this.isChangelogOpen = true;
      console.log("📢 New changelog version available, auto-opening...");
    }
  }

  /**
   * Mark the current changelog version as seen
   */
  private markChangelogAsSeen(): void {
    localStorage.setItem("changelogLastSeen", this.CHANGELOG_VERSION);
    console.log(
      "✅ Changelog marked as seen for version:",
      this.CHANGELOG_VERSION
    );
  }

  wrapTextAndConvertURLs(content: string, lineLength: number = 200) {
    // ngx-markdown handles markdown rendering in the template
    return content;
  }

  async getTokenCountWithFiles(
    userPrompt: string,
    modelName: string,
    files: any[]
  ): Promise<number> {
    // Fast path: some preview models may not support countTokens - use estimation
    if (modelName && (modelName.startsWith("gemini-2.5-flash") || modelName.startsWith("gemini-2.5-pro") || modelName.startsWith("gemini-3.5-flash") || modelName.startsWith("gemini-3.1-pro-preview"))) {
      const inputTokens = Math.ceil(userPrompt.length / 4);
      const fileTokens = files && files.length > 0 ? files.length * 85 : 0;
      const estimatedOutputTokens = Math.ceil(inputTokens * 1.5);
      return inputTokens + fileTokens + estimatedOutputTokens;
    }

    try {
      const parts: any[] = [{ text: userPrompt }];

      if (files && files.length > 0) {
        const inlineDataArray = files
          .filter((file: any) => file.base64)
          .map((file: any) => ({
            inline_data: {
              mime_type: file.type || "",
              data: file.base64,
            },
          }));
        parts.push(...inlineDataArray);
      }

      // Use backend service for countTokens (API key stays server-side)
      const contents = [{ role: "user", parts }];
      const result = await this.geminiService.countTokens(modelName, contents).toPromise();
      
      if (result && result.totalTokens) {
        return result.totalTokens;
      }
      throw new Error("Invalid response from countTokens API");
    } catch (error: any) {
      console.warn(
        "countTokens not available; using estimation fallback:",
        error
      );
      const inputTokens = Math.ceil(userPrompt.length / 4);
      const fileTokens = files && files.length > 0 ? files.length * 85 : 0;
      const estimatedOutputTokens = Math.ceil(inputTokens * 1.5);
      return inputTokens + fileTokens + estimatedOutputTokens;
    }
  }

  async checkTokenLimitBeforeSend(
    userPrompt: string,
    model: string,
    files: any[]
  ): Promise<boolean> {
    this.isLoading = true;

    const modelName = String(model).replace("search", "").trim();

    const conversationParts: any[] = [];

    if (this.chatHistory && this.chatHistory.length > 0) {
      for (const msg of this.chatHistory) {
        const parts: any[] = [{ text: msg.content || "" }];
        const fileArray = this.getSafeFileArray(msg.file);
        if (fileArray.length > 0) {
          const inlineData = fileArray
            .filter((file: any) => file.base64)
            .map((file: any) => ({
              inline_data: {
                mime_type: file.type || "",
                data: file.base64,
              },
            }));
          parts.push(...inlineData);
        }
        conversationParts.push({
          role: msg.type === "user" ? "user" : "model",
          parts: parts,
        });
      }
    }

    const currentParts: any[] = [{ text: userPrompt }];
    if (files && files.length > 0) {
      const inlineDataArray = files
        .filter((file: any) => file.base64)
        .map((file: any) => ({
          inline_data: {
            mime_type: file.type || "",
            data: file.base64,
          },
        }));
      currentParts.push(...inlineDataArray);
    }

    conversationParts.push({
      role: "user",
      parts: currentParts,
    });

    // If model does not support countTokens, use estimation path
    if (modelName && (modelName.startsWith("gemini-2.5-flash") || modelName.startsWith("gemini-2.5-pro") || modelName.startsWith("gemini-3.5-flash") || modelName.startsWith("gemini-3.1-pro-preview"))) {
      const inputTokens = Math.ceil(userPrompt.length / 4);
      const fileTokens = files && files.length > 0 ? files.length * 85 : 0;
      const estimatedOutputTokens = Math.ceil(inputTokens * 1.5);
      const newTokensForThisExchange =
        inputTokens + fileTokens + estimatedOutputTokens;

      this.isLoading = false;
      this.updateDecreasingTokenLimit(newTokensForThisExchange, false);

      if (this.remainingTokens - newTokensForThisExchange <= 0) {
        const tokensNeeded = newTokensForThisExchange;
        const tokensShort = tokensNeeded - this.remainingTokens;
        const estimatedCharactersToRemove = Math.ceil(tokensShort * 4);

        this.messageService.showTokenLimitExceeded({
          model: this.selectdModel,
          tokensNeeded: tokensNeeded,
          tokensRemaining: this.remainingTokens,
          tokensShort: tokensShort,
          estimatedCharactersToReduce: estimatedCharactersToRemove,
          isEstimated: true
        });

        this.isTokenLimitExceeded = true;
        return false;
      }

      this.isTokenLimitExceeded = false;
      return true;
    }

    try {
      // Use backend service for countTokens (API key stays server-side)
      const result = await this.geminiService.countTokens(modelName, conversationParts).toPromise();
      
      this.isLoading = false;
      
      if (!result || !result.totalTokens) {
        throw new Error("Invalid response from countTokens API");
      }
      
      const totalTokens = result.totalTokens;
      // Calculate tokens for just this input/output pair
      const inputTokens = Math.ceil(userPrompt.length / 4);
      const estimatedOutputTokens = Math.ceil(inputTokens * 1.5); // Rough estimate for output
      const newTokensForThisExchange = inputTokens + estimatedOutputTokens;

      // Update decreasing token limit (pre-send check)
      this.updateDecreasingTokenLimit(newTokensForThisExchange, false);

      console.log(
        "Gemini Token Balance Check - Total Tokens:",
        totalTokens,
        "Max Allowed:",
        this.gemini_max_token
      );
      console.log("Gemini Token Balance:", this.balanced_token);

      // Check if we would exceed the decreasing token limit
      if (this.remainingTokens - newTokensForThisExchange <= 0) {
        const tokensNeeded = newTokensForThisExchange;
        const tokensShort = tokensNeeded - this.remainingTokens;
        const estimatedCharactersToRemove = Math.ceil(tokensShort * 4);

        this.messageService.showTokenLimitExceeded({
          model: this.selectdModel,
          tokensNeeded: tokensNeeded,
          tokensRemaining: this.remainingTokens,
          tokensShort: tokensShort,
          estimatedCharactersToReduce: estimatedCharactersToRemove,
          isEstimated: false
        });

        this.isTokenLimitExceeded = true;
        return false;
      }

      this.isTokenLimitExceeded = false;
      return true;
    } catch (error) {
      // Fallback when countTokens is not available/supported: estimate and proceed
      console.warn(
        "countTokens failed, falling back to estimation for pre-send check:",
        error
      );
      this.isLoading = false;

      const inputTokens = Math.ceil(userPrompt.length / 4);
      const fileTokens = files && files.length > 0 ? files.length * 85 : 0;
      const estimatedOutputTokens = Math.ceil(inputTokens * 1.5);
      const newTokensForThisExchange =
        inputTokens + fileTokens + estimatedOutputTokens;

      // Update decreasing token limit (pre-send check with estimation)
      this.updateDecreasingTokenLimit(newTokensForThisExchange, false);

      if (this.remainingTokens - newTokensForThisExchange <= 0) {
        const tokensNeeded = newTokensForThisExchange;
        const tokensShort = tokensNeeded - this.remainingTokens;
        const estimatedCharactersToRemove = Math.ceil(tokensShort * 4);

        this.messageService.showTokenLimitExceeded({
          model: this.selectdModel,
          tokensNeeded: tokensNeeded,
          tokensRemaining: this.remainingTokens,
          tokensShort: tokensShort,
          estimatedCharactersToReduce: estimatedCharactersToRemove,
          isEstimated: true
        });

        this.isTokenLimitExceeded = true;
        return false;
      }

      this.isTokenLimitExceeded = false;
      return true;
    }
  }

  private estimateGptTokens(messages: any[]): number {
    let tokens = 0;
    tokens += 3;

    for (const message of messages) {
      tokens += 4;

      if (Array.isArray(message.content)) {
        for (const item of message.content) {
          if (item.type === "text") {
            tokens += Math.ceil(item.text.length / 4);
          } else if (item.type === "image_url") {
            tokens += 85;
          }
        }
      } else if (typeof message.content === "string") {
        tokens += Math.ceil(message.content.length / 4);
      }
    }
    tokens += 3;
    return Math.ceil(tokens);
  }

  // Method to track cumulative tokens across conversation
  private updateCumulativeTokens(
    newTokens: number,
    isNewMessage: boolean = false
  ): void {
    if (isNewMessage) {
      // Add tokens for new input/output pair
      this.conversationTokens += newTokens;

      // Store in session history if we have a current session
      if (this.currentSessionId) {
        this.sessionTokenHistory[this.currentSessionId] =
          this.conversationTokens;
      }
    } else {
      // Just update the current total (for pre-send checks)
      this.conversationTokens = newTokens;
    }

    this.total_used_token = this.conversationTokens;

    // Update balanced tokens based on current model
    const maxTokens = this.selectdModel.startsWith("gemini")
      ? this.gemini_max_token
      : this.gpt_max_token;
    this.balanced_token = maxTokens - this.conversationTokens;

    console.log("Cumulative Token Update:", {
      conversationTokens: this.conversationTokens,
      newTokens: newTokens,
      isNewMessage: isNewMessage,
      balancedTokens: this.balanced_token,
      sessionId: this.currentSessionId,
    });
  }

  // Method to implement decreasing token limit simulation
  private updateDecreasingTokenLimit(
    tokensToDeduct: number,
    isNewMessage: boolean = false
  ): void {
    if (isNewMessage) {
      // Deduct tokens from remaining limit
      this.remainingTokens = Math.max(0, this.remainingTokens - tokensToDeduct);

      // Store in session history if we have a current session
      if (this.currentSessionId) {
        this.sessionRemainingTokens[this.currentSessionId] =
          this.remainingTokens;
      }
    } else {
      // For pre-send checks, calculate what remaining tokens would be
      const potentialRemaining = Math.max(
        0,
        this.remainingTokens - tokensToDeduct
      );

      // Update display values
      this.total_used_token = this.initialTokenLimit - potentialRemaining;
      this.balanced_token = potentialRemaining;

      console.log("Pre-send Token Check:", {
        currentRemaining: this.remainingTokens,
        tokensToDeduct: tokensToDeduct,
        potentialRemaining: potentialRemaining,
        wouldExceedLimit: potentialRemaining <= 0,
      });
      return;
    }

    // Update display values for actual token deduction
    this.total_used_token = this.initialTokenLimit - this.remainingTokens;
    this.balanced_token = this.remainingTokens;

    console.log("Decreasing Token Limit Update:", {
      tokensDeducted: tokensToDeduct,
      remainingTokens: this.remainingTokens,
      totalUsed: this.total_used_token,
      sessionId: this.currentSessionId,
      isNewMessage: isNewMessage,
    });

    // Warn if approaching limit
    if (this.remainingTokens < this.initialTokenLimit * 0.1) {
      console.warn(
        "⚠️ Approaching token limit! Only",
        this.remainingTokens,
        "tokens remaining"
      );
    }
  }

  // Method to restore token count for a session
  private restoreSessionTokens(sessionId: string): void {
    // Set initial token limit based on current model
    this.initialTokenLimit = this.selectdModel.startsWith("gemini")
      ? this.gemini_max_token
      : this.gpt_max_token;

    if (this.sessionRemainingTokens[sessionId] !== undefined) {
      // Restore decreasing token limit for existing session
      this.remainingTokens = this.sessionRemainingTokens[sessionId];
      this.total_used_token = this.initialTokenLimit - this.remainingTokens;
      this.balanced_token = this.remainingTokens;

      console.log("Restored session decreasing tokens:", {
        sessionId: sessionId,
        remainingTokens: this.remainingTokens,
        totalUsed: this.total_used_token,
        initialLimit: this.initialTokenLimit,
      });
    } else {
      // New session or first time - start with full token limit
      this.remainingTokens = this.initialTokenLimit;

      // If there's existing chat history, deduct those tokens
      if (this.chatHistory && this.chatHistory.length > 0) {
        const historyTokens = this.calculateHistoryTokens();
        this.remainingTokens = Math.max(
          0,
          this.initialTokenLimit - historyTokens
        );
        this.sessionRemainingTokens[sessionId] = this.remainingTokens;
      }

      this.total_used_token = this.initialTokenLimit - this.remainingTokens;
      this.balanced_token = this.remainingTokens;

      console.log("Initialized session decreasing tokens:", {
        sessionId: sessionId,
        initialLimit: this.initialTokenLimit,
        remainingTokens: this.remainingTokens,
        totalUsed: this.total_used_token,
      });
    }

    // Also maintain cumulative tracking for compatibility
    if (this.sessionTokenHistory[sessionId]) {
      this.conversationTokens = this.sessionTokenHistory[sessionId];
    } else {
      this.conversationTokens = this.calculateHistoryTokens();
      this.sessionTokenHistory[sessionId] = this.conversationTokens;
    }
  }

  // Calculate tokens from existing chat history
  private calculateHistoryTokens(): number {
    if (!this.chatHistory || this.chatHistory.length === 0) {
      return 0;
    }

    let totalTokens = 0;
    for (const message of this.chatHistory) {
      // Rough estimation: 4 characters per token
      totalTokens += Math.ceil(message.content.length / 4);

      // Add tokens for files if present
      const fileArray = this.getSafeFileArray(message.file);
      if (fileArray.length > 0) {
        totalTokens += fileArray.length * 85; // Rough estimate for images
      }
    }

    return totalTokens;
  }

  async checkGptTokenLimitBeforeSend(
    userPrompt: string,
    model: string,
    files: any[]
  ): Promise<boolean> {
    this.isLoading = true;

    const messagesForGptTokenCheck: any[] = [
      { role: "system", content: this.systemPrompt },
    ];

    for (const msg of this.chatHistory) {
      // Skip empty or placeholder assistant messages
      const fileArray = this.getSafeFileArray(msg.file);
      if ((msg.type === "gpt" || msg.type === "model" || msg.type === "assistant") && !(msg.content || "").trim() && fileArray.length === 0) {
        continue;
      }
      if (msg.type === "user" || msg.type === "gpt" || msg.type === "model" || msg.type === "assistant") {
        const contentParts: any[] = [{ type: "text", text: msg.content || "" }];
        if (fileArray.length > 0) {
          contentParts.push(
            ...fileArray.map((file: any) => ({
              type: "image_url",
              image_url: { url: `data:${file.type};base64,${file.base64}` },
            }))
          );
        }
        messagesForGptTokenCheck.push({
          role: msg.type === "user" ? "user" : "assistant",
          content: contentParts,
        });
      }
    }

    const currentUserPromptContent: any[] = [
      { type: "text", text: userPrompt },
    ];
    if (files && files.length > 0) {
      currentUserPromptContent.push(
        ...files.map((file: any) => ({
          type: "image_url",
          image_url: { url: `data:${file.type};base64,${file.base64}` },
        }))
      );
    }
    messagesForGptTokenCheck.push({
      role: "user",
      content: currentUserPromptContent,
    });

    const currentTokenCount = this.estimateGptTokens(messagesForGptTokenCheck);
    // Calculate tokens for just this input/output pair
    const inputTokens = Math.ceil(userPrompt.length / 4);
    const estimatedOutputTokens = Math.ceil(inputTokens * 1.5); // Rough estimate for output
    const newTokensForThisExchange = inputTokens + estimatedOutputTokens;

    // Update decreasing token limit (pre-send check)
    this.updateDecreasingTokenLimit(newTokensForThisExchange, false);

    console.log(
      "GPT Token Balance Check - Total Tokens:",
      currentTokenCount,
      "Max Allowed:",
      this.gpt_max_token
    );
    console.log("GPT Token Balance:", this.balanced_token);

    this.isLoading = false;

    // Check if we would exceed the decreasing token limit
    if (this.remainingTokens - newTokensForThisExchange <= 0) {
      const tokensNeeded = newTokensForThisExchange;
      const tokensShort = tokensNeeded - this.remainingTokens;
      const estimatedCharactersToReduce = Math.ceil(tokensShort * 4);

      this.messageService.showTokenLimitExceeded({
        model: this.selectdModel,
        tokensNeeded: tokensNeeded,
        tokensRemaining: this.remainingTokens,
        tokensShort: tokensShort,
        estimatedCharactersToReduce: estimatedCharactersToReduce,
        isEstimated: false
      });

      this.isTokenLimitExceeded = true;
      return false;
    } else {
      this.isTokenLimitExceeded = false;
      return true;
    }
  }

  async getResponseStream(
    prompt: string,
    model_choice: string,
    selectdTemperature: number,
    onData: (chunk: string) => void,
    onComplete?: () => void,
    onError?: (error: any) => void,
    disableThinking?: boolean
  ): Promise<void> {
    try {
      const modelName = String(model_choice).replace("search", "").trim();

      // Check if there are any files in current message or conversation history
      const hasFiles =
        this.selectedFiles.length > 0 ||
        this.chatHistory.some((msg) => this.getSafeFileArray(msg.file).length > 0);

      // Build conversation history
      const conversationHistory = this.chatHistory
        .filter(
          (msg) =>
            (msg.content || "").trim() !== "" || this.getSafeFileArray(msg.file).length > 0
        )
        .map((msg) => {
          const parts: any[] = [{ text: msg.content || "" }];
          const fileArray = this.getSafeFileArray(msg.file);
          if (fileArray.length > 0) {
            const inlineData = fileArray
              .filter((file: any) => file.base64)
              .map((file: any) => ({
                inline_data: {
                  mime_type: file.type || "",
                  data: file.base64,
                },
              }));
            parts.push(...inlineData);
          }
          return {
            role: msg.type === "user" ? "user" : "model",
            parts: parts,
          };
        });
      
      const currentParts: any[] = [{ text: prompt }];
      if (this.selectedFiles && this.selectedFiles.length > 0) {
        const inlineDataArray = this.selectedFiles
          .filter((file: any) => file.base64)
          .map((file: any) => ({
            inline_data: {
              mime_type: file.type || "",
              data: file.base64,
            },
          }));
        currentParts.push(...inlineDataArray);
      }
      conversationHistory.push({ role: "user", parts: currentParts });
      const contents = conversationHistory;
      
      if (conversationHistory.length === 0) {
        throw new Error("No content provided for chat.");
      }

      // Build tools configuration
      let geminiTools: any = {};
      if (!hasFiles) {
        if (modelName.startsWith("gemini-1.5-pro")) {
          geminiTools = { google_search_retrieval: {} };
        } else if (
          modelName.startsWith("gemini-2.0-flash") ||
          modelName.startsWith("gemini-2.5-pro") ||
          modelName.startsWith("gemini-2.5-flash") ||
          modelName.startsWith("gemini-3.5-flash") ||
          modelName.startsWith("gemini-3.1-pro-preview")
        ) {
          geminiTools = { google_search: {} };
        }
      }

      const generationConfig = {
        temperature: selectdTemperature,
      };

      const systemInstruction = `${this.systemPrompt}\n${this.getCreativityStyleNote()}`;

      // Get user_id and session_id for logging
      const userId = localStorage.getItem('userId') || undefined;
      const sessionId = this.currentSessionId || undefined;

      // Use backend service for streaming (API key stays server-side)
      const stream$ = this.geminiService.streamContent(
        modelName,
        contents,
        generationConfig,
        systemInstruction,
        hasFiles ? undefined : geminiTools,
        userId,
        sessionId,
        disableThinking
      );

      stream$.subscribe({
        next: (chunk: string) => {
          if (chunk) {
            onData(chunk);
          }
        },
        error: (err: any) => {
          console.error("Gemini Streaming error:", err);
          
          // Use standardized retry error message
          this.messageService.showRetryError();
          if (onError) {
            onError({
              ...err,
              userFriendlyMessage: "Unable to complete your request after 3 attempts. Your chat session is still active - please try again.",
            });
          }
        },
        complete: () => {
          if (onComplete) onComplete();
        }
      });
    } catch (error: any) {
      console.error("Error streaming response:", error);

      // Always show standardized unexpected error
      this.messageService.showUnexpectedError();

      // Still pass error details to callback (if needed)
      if (onError) {
        onError({
          ...error,
          userFriendlyMessage: "An unexpected error occurred. Please try again.",
        });
      }
    }
  }

  getSearchResults() {}

  async getStreamingResponse(
    userPrompt: string,
    model: string,
    selectdTemperature: number
  ) {
    // This method is likely deprecated if sendPrompt handles both.
    // Consider removing if it's not used.
  }

  applyFormatting(text: string): string {
    if (!text) return '';
    
    // CRITICAL FIX: Clean up excessive newlines FIRST (before any processing)
    // This prevents list items from being separated by large gaps
    text = text.replace(/\n{3,}/g, '\n\n');
    
    // Store already-processed HTML blocks to preserve them
    const htmlBlocks: string[] = [];
    let htmlBlockIndex = 0;
    
    // Code blocks (triple backticks) - must be processed before other markdown
    text = text.replace(/```([\s\S]*?)```/g, (match, code) => {
      const blockId = `__HTML_BLOCK_${htmlBlockIndex++}__`;
      htmlBlocks.push(`<pre><code>${this.escapeHtml(code.trim())}</code></pre>`);
      return blockId;
    });
    
    // Inline code (single backticks)
    text = text.replace(/`([^`]+)`/g, (match, code) => {
      const blockId = `__HTML_BLOCK_${htmlBlockIndex++}__`;
      htmlBlocks.push(`<code>${this.escapeHtml(code)}</code>`);
      return blockId;
    });
    
    // Tables - process before other markdown that might interfere
    text = this.renderTables(text, htmlBlocks, htmlBlockIndex);
    htmlBlockIndex = htmlBlocks.length;
    
    // Now escape the remaining text to prevent XSS
    text = this.escapeHtml(text);
    
    // Restore HTML blocks
    htmlBlocks.forEach((block, index) => {
      text = text.replace(`__HTML_BLOCK_${index}__`, block);
    });
    
    // Headers (process after escaping, but need to re-process)
    text = text.replace(/^### (.*$)/gim, '<h3>$1</h3>');
    text = text.replace(/^## (.*$)/gim, '<h2>$1</h2>');
    text = text.replace(/^# (.*$)/gim, '<h1>$1</h1>');
    
    // Bold and italic (bold first to avoid conflicts)
    text = text.replace(/\*\*\*(.*?)\*\*\*/g, '<strong><em>$1</em></strong>');
    text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    text = text.replace(/\*(.*?)\*/g, '<em>$1</em>');
    
    // Strikethrough
    text = text.replace(/~~(.*?)~~/g, '<del>$1</del>');
    
    // Links
    text = text.replace(
      /\[([^\]]+)\]\(([^)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );
    
    // Images
    text = text.replace(
      /!\[([^\]]*)\]\(([^)]+)\)/g,
      '<img src="$2" alt="$1" style="max-width: 100%; height: auto;" />'
    );
    
    // Horizontal rules
    text = text.replace(/^---$/gm, '<hr>');
    text = text.replace(/^\*\*\*$/gm, '<hr>');
    
    // IMPROVED LIST PROCESSING - Groups list items even with multiple newlines between them
    // First, mark all list items
    text = text.replace(/^[\*\-\+]\s+(.+)$/gm, '___UL___<li>$1</li>');
    text = text.replace(/^\d+\.\s+(.+)$/gm, '___OL___<li>$1</li>');
    
    // Now process line by line to group consecutive list items
    const lines = text.split('\n');
    let result: string[] = [];
    let currentListType: string | null = null;
    let listItems: string[] = [];
    
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();
      
      // Check if this is a list item
      const ulMatch = line.match(/^___UL___(.*)$/);
      const olMatch = line.match(/^___OL___(.*)$/);
      
      if (ulMatch) {
        // Unordered list item
        if (currentListType !== 'ul') {
          // Close previous list if any
          if (currentListType === 'ol' && listItems.length > 0) {
            result.push('<ol>' + listItems.join('') + '</ol>');
          }
          currentListType = 'ul';
          listItems = [];
        }
        listItems.push(ulMatch[1]);
      } else if (olMatch) {
        // Ordered list item
        if (currentListType !== 'ol') {
          // Close previous list if any
          if (currentListType === 'ul' && listItems.length > 0) {
            result.push('<ul>' + listItems.join('') + '</ul>');
          }
          currentListType = 'ol';
          listItems = [];
        }
        listItems.push(olMatch[1]);
      } else {
        // Not a list item
        // Close current list if any
        if (currentListType === 'ul' && listItems.length > 0) {
          result.push('<ul>' + listItems.join('') + '</ul>');
          listItems = [];
          currentListType = null;
        } else if (currentListType === 'ol' && listItems.length > 0) {
          result.push('<ol>' + listItems.join('') + '</ol>');
          listItems = [];
          currentListType = null;
        }
        
        // Only add non-empty lines
        if (line) {
          result.push(line);
        }
      }
    }
    
    // Close any remaining list
    if (currentListType === 'ul' && listItems.length > 0) {
      result.push('<ul>' + listItems.join('') + '</ul>');
    } else if (currentListType === 'ol' && listItems.length > 0) {
      result.push('<ol>' + listItems.join('') + '</ol>');
    }
    
    text = result.join('\n');
    
    // Blockquotes
    text = text.replace(/^>\s+(.+)$/gm, '<blockquote>$1</blockquote>');
    
    // ChatGPT-style line break handling - more intelligent spacing
    // Split by double newlines for paragraphs, but be smarter about it
    const blocks = text.split(/\n\n+/);
    const processedBlocks = blocks.map(block => {
      block = block.trim();
      if (!block) return '';
      
      // Don't wrap if already has block-level tags
      if (block.match(/^<(p|pre|ul|ol|table|h[1-6]|blockquote|hr|div)/)) {
        return block;
      }
      
      // For plain text blocks, convert single newlines to <br> only within the block
      block = block.replace(/\n/g, '<br>');
      
      // Wrap in paragraph
      return '<p>' + block + '</p>';
    });
    
    text = processedBlocks.filter(b => b).join('\n');
    
    // Clean up any remaining issues
    // Remove empty paragraphs
    text = text.replace(/<p>\s*<\/p>/g, '');
    // Remove excessive <br> tags (more than 1 consecutive)
    text = text.replace(/(<br\s*\/?>){2,}/gi, '<br>');
    // Remove whitespace between block elements
    text = text.replace(/(<\/(ul|ol|blockquote|pre|table)>)\s+(<(ul|ol|blockquote|pre|table|h[1-6]|p))/g, '$1\n$3');
    
    return text;
  }

  private escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  private renderTables(text: string, htmlBlocks: string[] = [], startIndex: number = 0): string {
    // Match markdown tables
    // Pattern: | header1 | header2 |\n|--------|--------|\n| cell1 | cell2 |
    const tableRegex = /(\|.+\|\r?\n\|[-\s|:]+\|\r?\n(?:\|.+\|\r?\n?)+)/g;
    let blockIndex = startIndex;
    
    return text.replace(tableRegex, (match) => {
      const lines = match.trim().split('\n').filter(line => line.trim());
      if (lines.length < 2) return match;
      
      // Parse header
      const headerLine = lines[0];
      const headers = headerLine.split('|')
        .map(h => h.trim())
        .filter(h => h.length > 0);
      
      // Skip separator line (line 1)
      // Parse data rows
      const rows: string[][] = [];
      for (let i = 2; i < lines.length; i++) {
        const cells = lines[i].split('|')
          .map(c => c.trim())
          .filter(c => c.length > 0);
        if (cells.length > 0) {
          rows.push(cells);
        }
      }
      
      // Build HTML table
      let html = '<table class="markdown-table" style="border-collapse: collapse; width: 100%; margin: 1em 0;">';
      
      // Header row
      html += '<thead><tr>';
      headers.forEach(header => {
        html += `<th style="border: 1px solid #ddd; padding: 8px; text-align: left; background-color: #f2f2f2; font-weight: bold;">${this.escapeHtml(header)}</th>`;
      });
      html += '</tr></thead>';
      
      // Body rows
      html += '<tbody>';
      rows.forEach(row => {
        html += '<tr>';
        // Ensure we have the same number of cells as headers
        for (let i = 0; i < headers.length; i++) {
          const cell = row[i] || '';
          html += `<td style="border: 1px solid #ddd; padding: 8px;">${this.escapeHtml(cell)}</td>`;
        }
        html += '</tr>';
      });
      html += '</tbody></table>';
      
      // Store table HTML and return placeholder
      const blockId = `__HTML_BLOCK_${blockIndex++}__`;
      htmlBlocks.push(html);
      return blockId;
    });
  }

  private getCreativityStyleNote(): string {
    try {
      const t = Number(this.selectdTemperature);
      if (isNaN(t)) return "";
      if (t <= 0.3) {
        return "Style: Be concise and factual. Keep answers short with minimal elaboration.";
      }
      if (t >= 0.95) {
        return "Style: Be more exploratory and creative. Offer alternatives and richer detail where helpful.";
      }
      return "Style: Balanced tone. Provide clear, complete answers with moderate detail.";
    } catch {
      return "";
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const dropZone = event.currentTarget as HTMLElement;
    dropZone.classList.add("active");
  }

  onDragLeave(event: DragEvent) {
    const dropZone = event.currentTarget as HTMLElement;
    dropZone.classList.remove("active");
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const dropZone = event.currentTarget as HTMLElement;
    dropZone.classList.remove("active");

    if (event.dataTransfer?.files.length) {
      const files = Array.from(event.dataTransfer.files);

      const gptAllowedTypes = [
        "image/jpeg",
        "image/png",
        "image/svg+xml",
        "image/webp",
      ];
      const geminiAllowedTypes = [
        "application/pdf",
        "text/plain",
        "text/csv",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ...gptAllowedTypes,
      ];

      const allowedTypes = this.selectdModel.startsWith("gemini")
        ? geminiAllowedTypes
        : gptAllowedTypes;

      const maxSizeMB = this.selectdModel.startsWith("gemini") ? 7 : 10;
      const maxSizeBytes = maxSizeMB * 1024 * 1024;

      let totalSize = 0;
      const validFiles: File[] = [];
      const invalidFiles: string[] = [];

      for (const file of files) {
        totalSize += file.size;
        if (!allowedTypes.includes(file.type)) {
          invalidFiles.push(`${file.name} (type: ${file.type})`);
        } else {
          validFiles.push(file);
        }
      }

      if (invalidFiles.length > 0) {
        this.messageService.showInvalidFilesWithList(invalidFiles, this.selectdModel, maxSizeMB);
      }

      if (totalSize > maxSizeBytes) {
        this.messageService.showCombinedFileSizeExceeded(this.selectdModel, maxSizeMB);
        return;
      }

      if (validFiles.length > 0) {
        this.onFileSelected({ target: { files: validFiles } });
      }
    }
  }

  async onFileSelected(e: any) {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const maxSizeMB = this.selectdModel.startsWith("gemini") ? 7 : 10;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    let existingSize = this.selectedFiles.reduce(
      (acc, file) => acc + (file.size || 0),
      0
    );

    let incomingSize = 0;
    for (const file of files) {
      incomingSize += file.size;
    }

    if (existingSize + incomingSize > maxSizeBytes) {
      this.messageService.showCombinedFileSizeExceeded(this.selectdModel, maxSizeMB);
      return;
    }

    for (const file of files) {
      const fileType = file.type;
      const reader = new FileReader();
      const fileData: any = {
        name: file.name,
        type: fileType,
        preview: "",
        base64: "",
        img: "",
        size: file.size,
      };

      if (fileType.startsWith("image/") || fileType === "application/pdf") {
        reader.onload = () => {
          fileData.preview = reader.result as string;
          fileData.img =
            fileType === "application/pdf"
              ? "assets/files/pdf.png"
              : fileData.preview;
          fileData.base64 = fileData.preview.split(",")[1];
          this.selectedFiles.push(fileData);
        };
        reader.readAsDataURL(file);
      } else if (fileType === "text/plain" || fileType === "text/csv") {
        reader.onload = () => {
          fileData.preview = reader.result as string;
          fileData.img =
            fileType === "text/plain"
              ? "assets/files/txt-file.png"
              : "assets/files/csv.png";
          fileData.base64 = btoa(
            unescape(encodeURIComponent(fileData.preview))
          );
          this.selectedFiles.push(fileData);
        };
        reader.readAsText(file);
      } else if (
        fileType === "application/vnd.ms-excel" ||
        fileType ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        reader.onload = (e: any) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const extractedData = XLSX.utils.sheet_to_json(sheet);
          fileData.preview = JSON.stringify(extractedData, null, 2);
          fileData.img = "assets/files/xls-file.png";
          fileData.base64 = btoa(
            unescape(encodeURIComponent(fileData.preview))
          );
          fileData.type = "text/plain";
          this.selectedFiles.push(fileData);
        };
        reader.readAsArrayBuffer(file);
      } else if (
        fileType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        reader.onload = async () => {
          try {
            const arrayBuffer = reader.result as ArrayBuffer;
            const result = await mammoth.extractRawText({ arrayBuffer });
            fileData.preview = result.value;
            fileData.img = "assets/files/docx-file.png";
            fileData.base64 = btoa(
              unescape(encodeURIComponent(fileData.preview))
            );
            fileData.type = "text/plain";
            this.selectedFiles.push(fileData);
          } catch (error) {
            console.error("Error extracting text from DOCX:", error);
          }
        };
        reader.readAsArrayBuffer(file);
      } else {
        this.messageService.showUnsupportedFileType();
      }
    }

    setTimeout(() => {
      const textarea = document.getElementById("myTextArea");
      textarea?.focus();
    }, 200);
  }
  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
    this.triggerClearAllElement();
  }

  clearAllFiles() {
    this.selectedFiles = [];
    this.triggerClearAllElement();
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  }

  async sendPrompt() {
    if (!this.userPrompt.trim() && this.selectedFiles.length === 0) return;

    // Handle DALL-E image generation
    if (this.isDallESelected) {
      await this.generateImage();
      return;
    }

    // Reset the new chat flag since user is now interacting
    this.isStartingNewChat = false;

    // UNBLOCK session changes since user is now actually interacting
    this.chatSessionService.unblockNewChatSessionChanges();

    // Create a session if none exists (first interaction)
    if (!this.currentSessionId) {
      const newSession =
        this.chatSessionService.createSessionOnFirstInteraction(
          this.selectdModel,
          this.selectdTemperature
        );
      this.currentSessionId = newSession.id;
      this.currentSessionName = newSession.name;
      this.chatHistory = [];
    }

    const currentDate = moment().tz("America/New_York").format("lll");
    const userMessageForHistory: ChatMessage = {
      type: "user",
      content: this.userPrompt,
      date: currentDate,
      file: [...this.selectedFiles],
    };

    let canSend = false;

    try {
      if (this.selectdModel.startsWith("gemini")) {
        // Use Gemini token check for Gemini models only
        canSend = await this.checkTokenLimitBeforeSend(
          this.userPrompt,
          this.selectdModel,
          this.selectedFiles
        );
      } else {
        canSend = await this.checkGptTokenLimitBeforeSend(
          this.userPrompt,
          this.selectdModel,
          this.selectedFiles
        );
      }
    } catch (tokenError) {
      console.error("Error during token limit verification:", tokenError);
      this.isLoading = false;
      this.messageService.showError("An error occurred while preparing your message. Please try again.", "Error");
      this.focusTextArea();
      return;
    }

    if (!canSend) {
      this.isLoading = false;
      this.focusTextArea();
      return;
    }

    this.chatHistory.push(userMessageForHistory);
    this.shouldAutoScroll = true; // Ensure we scroll after user sends a message
    this.scrollToBottom(); // Force scroll after user sends message

    // Start timing for the request
    this.requestStartTime = this.appInsightsService.startTiming();
    console.log("⏱️ TIMING STARTED:", {
      model: this.selectdModel,
      temperature: this.selectdTemperature,
      promptLength: userMessageForHistory.content.length,
      timestamp: new Date().toISOString(),
    });
    const modelResponsePlaceholder: ChatMessage = {
      type: this.selectdModel.startsWith("gemini") ? "model" : "gpt",
      content: "",
      date: currentDate,
    };
    this.chatHistory.push(modelResponsePlaceholder);
    this.scrollToStartOfLastAssistantMessage();

    this.userPrompt = "";
    this.selectedFiles = [];
    if (this.myTextArea && this.myTextArea.nativeElement) {
      this.myTextArea.nativeElement.value = "";
      // Reset textarea height after sending
      this.myTextArea.nativeElement.style.height = 'auto';
    }
    this.triggerClearAllElement();

    this.isLoading = true;

    if (this.selectdModel.startsWith("gemini")) {
      // Gemini models route to Gemini backend
      this.getResponseStream(
        userMessageForHistory.content,
        this.selectdModel,
        this.selectdTemperature,
        (chunk) => {
          modelResponsePlaceholder.content = this.decodeHtmlEntities(modelResponsePlaceholder.content + chunk);
          this.cdr.detectChanges();
        },
        () => {
          this.isLoading = false;
          this.scrollToStartOfLastAssistantMessage();

          // Calculate actual tokens for the completed input/output pair
          const inputTokens = Math.ceil(
            userMessageForHistory.content.length / 4
          );
          const outputTokens = Math.ceil(
            modelResponsePlaceholder.content.length / 4
          );
          const actualTokens = inputTokens + outputTokens;

          // Deduct actual tokens from remaining limit
          this.updateDecreasingTokenLimit(actualTokens, true);

          // Track timing for Gemini response (marked as pending)
          this.appInsightsService.trackEventWithTiming(
            "GeminiChatResponse",
            this.requestStartTime,
            {
              model: this.selectdModel,
              temperature: this.selectdTemperature,
              promptLength: userMessageForHistory.content.length,
              responseLength: modelResponsePlaceholder.content.length,
              tokensUsed: actualTokens,
            }
          );

          this.updateCurrentSessionHistory();
          this.focusTextArea();
          this.cdr.detectChanges();
        },
        (error) => {
          console.error("Gemini Streaming error:", error);
          this.isLoading = false;
          this.revertLastChatEntry();

          // Use enhanced error message if available
          const errorMessage =
            error.userFriendlyMessage ||
            "An error occurred with Gemini. Please try a shorter prompt or clear chat.";

          this.messageService.showError(errorMessage, 'Error');

          this.focusTextArea();
        }
      );
    } else {
      const messagesForAzure: any = [
        { role: "system", content: this.systemPrompt },
      ];
      if (this.selectdModel === "gpt-5-mini") {
        const r = (this.selectedReasoning || "medium").toLowerCase();
        const note =
          r === "minimal"
            ? "Reasoning level: Minimal. Prioritize speed and concise answers with minimal explanation."
            : r === "low"
            ? "Reasoning level: Low. Provide brief justification with concise steps."
            : r === "high"
            ? "Reasoning level: High. Provide thorough, careful reasoning and explicit steps."
            : "Reasoning level: Medium. Balance brevity with clarity; include key steps where helpful.";
        messagesForAzure.push({ role: "system", content: note });
      } else {
        const style = this.getCreativityStyleNote();
        if (style) messagesForAzure.push({ role: "system", content: style });
      }

      // Add previous chat history to maintain conversation context
      // Only attach images for the current user message to avoid stale/stripped base64 in history
      for (const msg of this.chatHistory) {
        // Skip empty or placeholder assistant messages
        const fileArray = this.getSafeFileArray(msg.file);
        if ((msg.type === "gpt" || msg.type === "model" || msg.type === "assistant") && !(msg.content || "").trim() && fileArray.length === 0) {
          continue;
        }
        if (msg.type === "user" || msg.type === "gpt" || msg.type === "model" || msg.type === "assistant") {
          const contentParts: any[] = [{ type: "text", text: msg.content || "" }];
          if (msg === userMessageForHistory && fileArray.length > 0) {
            const imageParts = fileArray
              .map((file: any) => {
                const rawBase64 = (file.base64 || "").toString().trim().replace(/\s/g, "");
                if (!rawBase64) return null;
                const mime = file.type && typeof file.type === "string" && file.type.length > 0 ? file.type : "image/png";
                return {
                  type: "image_url",
                  image_url: { url: `data:${mime};base64,${rawBase64}` },
                };
              })
              .filter(Boolean);
            if (imageParts.length > 0) {
              contentParts.push(...imageParts as any[]);
            }
          }
          messagesForAzure.push({
            role: msg.type === "user" ? "user" : "assistant",
            content: contentParts,
          });
        }
      }

      const userId = localStorage.getItem('userId') || undefined;
      const sessionId = this.currentSessionId || undefined;
      
      this.azureOpenAiService
        .getStreamingResponse(
          { messages: messagesForAzure },
          this.selectdModel,
          this.selectdTemperature,
          this.selectedReasoning,
          userId,
          sessionId
        )
        .then((reader: ReadableStreamDefaultReader<Uint8Array> | undefined) => {
          if (reader) {
            const decoder = new TextDecoder();
            let streamingContent = "";
            let citations: string[] = [];
            let hasReceivedError = false;

            const processChunk = async () => {
              try {
                const { done, value } = await reader.read();

                if (done) {
                  this.isLoading = false;
                  
                  // Check if we received any error during streaming
                  if (hasReceivedError || !streamingContent) {
                    // Remove the placeholder message if we got an error
                    this.revertLastChatEntry();
                    
                    this.messageService.showRetryError();
                    
                    this.focusTextArea();
                    this.cdr.detectChanges();
                    return;
                  }
                  
                  modelResponsePlaceholder.content = this.decodeHtmlEntities(streamingContent);
                  modelResponsePlaceholder.references = citations;
                  this.scrollToStartOfLastAssistantMessage();

                  // Calculate actual tokens for the completed input/output pair
                  const inputTokens = Math.ceil(
                    userMessageForHistory.content.length / 4
                  );
                  const outputTokens = Math.ceil(streamingContent.length / 4);
                  const actualTokens = inputTokens + outputTokens;

                  // Deduct actual tokens from remaining limit
                  this.updateDecreasingTokenLimit(actualTokens, true);

                  // Track timing for GPT response (marked as pending)
                  this.appInsightsService.trackEventWithTiming(
                    "GPTChatResponse",
                    this.requestStartTime,
                    {
                      model: this.selectdModel,
                      temperature: this.selectdTemperature,
                      promptLength: userMessageForHistory.content.length,
                      responseLength: streamingContent.length,
                      tokensUsed: actualTokens,
                      citationsCount: citations.length,
                    }
                  );

                  this.updateCurrentSessionHistory();
                  this.focusTextArea();
                  this.cdr.detectChanges();
                  return;
                }

                const chunk = decoder.decode(value, { stream: true });

                chunk.split("\n").forEach((line) => {
                  if (line.startsWith("data: ")) {
                    const jsonData = line
                      .replace("data: ", "")
                      .replace("data: [DONE]", "")
                      .trim();
                    if (jsonData) {
                      try {
                        const parsed = JSON.parse(jsonData);
                        
                        // Check if this is an error message from backend
                        if (parsed.error) {
                          console.error("Backend error:", parsed.error);
                          hasReceivedError = true;
                          return;
                        }
                        
                        const delta = parsed.choices?.[0]?.delta || {};
                        let deltaContent = delta.content || "";
                        if (!deltaContent) {
                          const rc = (delta.reasoning_content || delta.reasoning || delta.output_text || "");
                          if (Array.isArray(rc)) {
                            deltaContent = rc.map((p: any) => p?.text || p?.content || "").join("");
                          } else if (typeof rc === "string") {
                            deltaContent = rc;
                          } else if (rc && typeof rc === "object" && (rc.text || rc.content)) {
                            deltaContent = rc.text || rc.content || "";
                          }
                        }

                        streamingContent += deltaContent;
                        modelResponsePlaceholder.content = this.decodeHtmlEntities(streamingContent);
                      } catch (error) {
                        console.error(
                          "Error parsing streaming response data from Azure:",
                          error
                        );
                      }
                    }
                  }
                });

                this.cdr.detectChanges();
                processChunk();
              } catch (readError) {
                console.error("Error reading Azure stream:", readError);
                this.isLoading = false;
                this.revertLastChatEntry();

                this.messageService.showConnectionIssue();

                this.focusTextArea();
              }
            };

            processChunk();
          } else {
            console.error("Failed to get streaming response reader from Azure after retries");
            this.isLoading = false;
            this.revertLastChatEntry();

            this.messageService.showRetryError();

            this.focusTextArea();
          }
        })
        .catch((initialError: any) => {
          console.error(
            "Error getting Azure streaming response after retries:",
            initialError
          );
          this.isLoading = false;
          this.revertLastChatEntry();

          this.messageService.showUnexpectedError();

          this.focusTextArea();
        });
    }
  }

  private revertLastChatEntry(): void {
    if (this.chatHistory.length >= 2) {
      const lastEntry = this.chatHistory[this.chatHistory.length - 1];
      const secondLastEntry = this.chatHistory[this.chatHistory.length - 2];

      if (
        (lastEntry.type === "model" || lastEntry.type === "gpt" || lastEntry.type === "assistant") &&
        secondLastEntry.type === "user"
      ) {
        this.chatHistory.pop();
        this.chatHistory.pop();
      }
    }
  }

  clearAll(
    fileInput: HTMLInputElement,
    fileInput1: HTMLInputElement,
    fileInput2: HTMLInputElement
  ): void {
    fileInput.value = "";
    fileInput1.value = "";
    fileInput2.value = "";
  }

  triggerClearAllElement() {
    document.getElementById("clearall")?.click();
  }

  focusTextArea() {
    setTimeout(() => {
      if (this.myTextArea && this.myTextArea.nativeElement) {
        this.myTextArea.nativeElement.focus();
      }
    }, 200);
  }
  isImage(url: string): boolean {
    return (
      url.startsWith("data:image/") ||
      url.includes(".png") ||
      url.includes(".jpg") ||
      url.includes(".jpeg") ||
      url.includes(".svg") ||
      url.includes(".webp")
    );
  }

  getFileIconClass(fileName: string): string {
    const ext = fileName.split('.').pop()?.toLowerCase() || '';
    switch (ext) {
      case 'pdf': return 'file-icon-pdf';
      case 'doc': case 'docx': return 'file-icon-docx';
      case 'xls': case 'xlsx': return 'file-icon-xls';
      case 'csv': return 'file-icon-csv';
      case 'txt': return 'file-icon-txt';
      default: return 'file-icon-generic';
    }
  }

  getFileIconLabel(fileName: string): string {
    const ext = fileName.split('.').pop()?.toUpperCase() || '';
    switch (ext) {
      case 'PDF': return 'PDF';
      case 'DOC': case 'DOCX': return 'DOC';
      case 'XLS': case 'XLSX': return 'XLS';
      case 'CSV': return 'CSV';
      case 'TXT': return 'TXT';
      default: return 'FILE';
    }
  }

  private scrollToBottom(): void {
    // Only scroll to bottom if the user is already near the bottom.
    // This prevents overriding the scroll position when a session loads
    // or when the user has scrolled up to read previous messages.
    if (!this.shouldAutoScroll) {
      return;
    }
    try {
      const el = document.getElementById("chat-container") as HTMLElement | null;
      if (!el) return;

      // Use a timeout to ensure scrolling happens after the DOM has updated.
      setTimeout(() => {
        el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
      }, 0);
    } catch (err) {
      console.error("Error scrolling to bottom:", err);
    }
  }

  // trackBy function for *ngFor on chatHistory - prevents unnecessary DOM re-creation
  trackByChatMessage(index: number, chat: any): string {
    return `${index}-${chat.type}-${chat.date || ''}`;
  }

  private scrollToStartOfLastAssistantMessage(): void {
    try {
      const container = document.getElementById("chat-container") as HTMLElement | null;
      if (!container) return;
      const assistantMessages = container.querySelectorAll(".ai-row");
      const lastAssistant = assistantMessages[assistantMessages.length - 1] as HTMLElement | null;
      if (!lastAssistant) return;

      const containerRect = container.getBoundingClientRect();
      const lastRect = lastAssistant.getBoundingClientRect();
      const offsetTop = lastRect.top - containerRect.top + container.scrollTop;

      setTimeout(() => {
        container.scrollTo({ top: Math.max(0, offsetTop), behavior: "smooth" });
      }, 0);
    } catch (err) {
      console.error("Scroll error:", err);
    }
  }

  private isUserNearBottom(): boolean {
    try {
      const el = document.getElementById("chat-container") as HTMLElement | null;
      if (!el) return true;

      const scrollTop = el.scrollTop;
      const scrollHeight = el.scrollHeight;
      const clientHeight = el.clientHeight;

      return scrollHeight - scrollTop - clientHeight < this.scrollThreshold;
    } catch (err) {
      console.error("Error checking scroll position:", err);
      return true;
    }
  }

  private setupScrollListener(): void {
    // Wait for view to be initialized
    setTimeout(() => {
      const el = document.getElementById("chat-container") as HTMLElement | null;
      if (!el) return;

      this.zone.runOutsideAngular(() => {
        let scrollTimeout: any;

        el.addEventListener(
          "scroll",
          () => {
            // Clear previous timeout
            if (scrollTimeout) {
              clearTimeout(scrollTimeout);
            }

            // Set flag that user is actively scrolling
            this.isUserScrolling = true;

            // Check if user is near bottom and update auto-scroll preference
            const scrollTop = el.scrollTop;
            const scrollHeight = el.scrollHeight;
            const clientHeight = el.clientHeight;
            this.shouldAutoScroll = scrollHeight - scrollTop - clientHeight < this.scrollThreshold;

            // Reset scrolling flag after user stops scrolling
            scrollTimeout = setTimeout(() => {
              this.isUserScrolling = false;
            }, 150);
          },
          { passive: true }
        );

        // Set up MutationObserver to auto-scroll to bottom on DOM mutations (streaming response)
        const observer = new MutationObserver(() => {
          if (this.shouldAutoScroll && !this.isUserScrolling) {
            el.scrollTop = el.scrollHeight;
          }
        });

        observer.observe(el, {
          childList: true,
          subtree: true,
          characterData: true
        });
      });
    }, 100);
  }

  handleKeyDown(event: KeyboardEvent) {
    if (
      event.key === "Enter" &&
      !event.shiftKey &&
      !this.isTokenLimitExceeded
    ) {
      this.sendPrompt();
      event.preventDefault();
    }
  }

  // Auto-resize textarea as user types
  autoResizeTextarea(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    // Reset height to auto to get the correct scrollHeight
    textarea.style.height = 'auto';
    // Calculate new height (limited by max-height in CSS - 150px)
    const maxHeight = 150;
    const newHeight = Math.min(textarea.scrollHeight, maxHeight);
    textarea.style.height = newHeight + 'px';
  }

  onMouseMove = (event: MouseEvent): void => {
    if (!this.isDragging) return;

    const deltaX = event.clientX - this.initialMouseX;
    let newWidth = this.initialSidebarWidth + deltaX;

    if (newWidth < this.minSidebarWidth) {
      newWidth = this.minSidebarWidth;
    }
    if (newWidth > this.maxSidebarWidth) {
      newWidth = this.maxSidebarWidth;
    }

    this.sidebarWidth = newWidth;
    this.calculateMainContentWidth();
  };

  onMouseUp = (): void => {
    this.isDragging = false;
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);
  };

  toggleSidebar() {
    if (this.isMobileView) {
      this.toggleMobileSidebar();
    } else {
      this.isSidebarHidden = !this.isSidebarHidden;
      if (!this.isSidebarHidden) {
        this.sidebarWidth = Math.floor(window.innerWidth * 0.15); // 15% of viewport
      }
      this.calculateMainContentWidth();
    }
  }

  toggleMobileSidebar() {
    this.isMobileSidebarActive = !this.isMobileSidebarActive;
    console.log("Mobile sidebar toggled:", this.isMobileSidebarActive);
  }

  closeMobileSidebar() {
    this.isMobileSidebarActive = false;
  }

  checkMobileView() {
    this.isMobileView = window.innerWidth <= 768;
    if (this.isMobileView) {
      this.isMobileSidebarActive = false;
    }
  }

  setupResizeListener() {
    window.addEventListener("resize", () => {
      this.checkMobileView();
      // Keep sidebar at 15% on window resize
      if (!this.isSidebarHidden) {
        this.sidebarWidth = Math.floor(window.innerWidth * 0.15);
      }
      this.calculateMainContentWidth();
    });
  }
  calculateMainContentWidth() {
    const appContainerWidth = this.el.nativeElement.offsetWidth;
    const resizerWidth = 5;

    if (this.isSidebarHidden) {
      this.mainContentWidth = appContainerWidth;
    } else {
      this.mainContentWidth =
        appContainerWidth - this.sidebarWidth - resizerWidth;
    }
  }

  initializeUserProfile(): void {
    try {
      const account = this.msalService.instance.getActiveAccount();
      const storedEmail = localStorage.getItem('email');
      const email = account?.username || storedEmail || null;
      const nameFromAccount = account?.name && account.name.trim().length > 0 ? account.name : null;
      const nameFromEmail = email ? email.split('@')[0] : null;
      this.userDisplayEmail = email;
      this.userDisplayName = nameFromAccount || nameFromEmail;
      
      // Fetch profile picture from Microsoft Graph API
      this.fetchUserProfilePicture();
    } catch (e) {
      const storedEmail = localStorage.getItem('email');
      this.userDisplayEmail = storedEmail;
      this.userDisplayName = storedEmail ? storedEmail.split('@')[0] : null;
    }
  }

  fetchUserProfilePicture(): void {
    const account = this.msalService.instance.getActiveAccount();
    if (!account) return;

    // Request token for Microsoft Graph
    this.msalService.acquireTokenSilent({
      scopes: ['User.Read'],
      account: account
    }).subscribe({
      next: (result) => {
        // Fetch profile photo from Microsoft Graph
        this.http.get('https://graph.microsoft.com/v1.0/me/photo/$value', {
          headers: { Authorization: `Bearer ${result.accessToken}` },
          responseType: 'blob'
        }).subscribe({
          next: (blob) => {
            const reader = new FileReader();
            reader.onload = () => {
              this.userProfilePicture = reader.result as string;
              this.cdr.detectChanges();
            };
            reader.readAsDataURL(blob);
          },
          error: () => {
            // No profile picture available, will use default image
            this.userProfilePicture = null;
          }
        });
      },
      error: () => {
        // Token acquisition failed, will use default image
        this.userProfilePicture = null;
      }
    });
  }

  getProfileImageUrl(): string {
    return this.userProfilePicture || 'assets/img/user.png';
  }

  toggleUserDropdown(event: Event): void {
    event.stopPropagation();
    this.isUserDropdownOpen = !this.isUserDropdownOpen;
    this.isNotificationDropdownOpen = false;
    this.isFontSizeDropdownOpen = false;
  }

  toggleNotificationDropdown(event: Event): void {
    event.stopPropagation();
    this.isNotificationDropdownOpen = !this.isNotificationDropdownOpen;
    this.isUserDropdownOpen = false;
    this.isFontSizeDropdownOpen = false;

    // Mark notification as read when opened
    if (this.isNotificationDropdownOpen && this.hasUnreadNotification) {
      this.markNotificationAsRead();
    }
  }

  closeNotificationDropdown(): void {
    this.isNotificationDropdownOpen = false;
  }

  checkNotificationStatus(): void {
    const lastSeenVersion = localStorage.getItem('lastSeenNotificationVersion');
    this.hasUnreadNotification = lastSeenVersion !== this.NOTIFICATION_VERSION;
  }

  markNotificationAsRead(): void {
    localStorage.setItem('lastSeenNotificationVersion', this.NOTIFICATION_VERSION);
    this.hasUnreadNotification = false;
  }

  toggleFontSizeDropdown(event: Event): void {
    event.stopPropagation();
    this.isFontSizeDropdownOpen = !this.isFontSizeDropdownOpen;
    this.isNotificationDropdownOpen = false;
    this.isUserDropdownOpen = false;
  }

  closeFontSizeDropdown(): void {
    this.isFontSizeDropdownOpen = false;
  }

  closeUserDropdown(): void {
    this.isUserDropdownOpen = false;
  }

  // ============================================================
  //  Export chats as a ZIP file
  // ============================================================

  // Open the export modal (triggered from the user dropdown)
  openExportModal(): void {
    this.isUserDropdownOpen = false;
    this.exportSelectedIds = new Set<string>();
    this.exportSortOrder = 'desc';
    this.exportStartDate = '';
    this.exportEndDate = '';
    this.isExporting = false;
    this.isExportModalOpen = true;
  }

  closeExportModal(): void {
    if (this.isExporting) {
      return; // Don't allow closing mid-export
    }
    this.isExportModalOpen = false;
  }

  // Sessions shown in the modal after applying date filters + sort order
  get exportFilteredSessions(): ChatSession[] {
    const start = this.exportStartDate ? new Date(this.exportStartDate + 'T00:00:00') : null;
    const end = this.exportEndDate ? new Date(this.exportEndDate + 'T23:59:59') : null;

    const filtered = (this.chatSessions || []).filter((session) => {
      const ts = new Date(session.timestamp).getTime();
      if (start && ts < start.getTime()) return false;
      if (end && ts > end.getTime()) return false;
      return true;
    });

    return filtered.sort((a, b) => {
      const diff = new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
      return this.exportSortOrder === 'asc' ? diff : -diff;
    });
  }

  // True when every currently-visible (filtered) session is selected
  get isAllExportSelected(): boolean {
    const visible = this.exportFilteredSessions;
    return visible.length > 0 && visible.every((s) => this.exportSelectedIds.has(s.id));
  }

  isExportSelected(sessionId: string): boolean {
    return this.exportSelectedIds.has(sessionId);
  }

  // Public title resolver for the export list (template-friendly)
  sanitizeTitleForDisplay(session: ChatSession): string {
    return this.sanitizeTitle(session.name || session.title) || 'Untitled Chat';
  }

  toggleExportSelection(sessionId: string): void {
    if (this.exportSelectedIds.has(sessionId)) {
      this.exportSelectedIds.delete(sessionId);
    } else {
      this.exportSelectedIds.add(sessionId);
    }
  }

  // "All" checkbox: select/deselect every visible (filtered) session
  toggleSelectAllExports(): void {
    const visible = this.exportFilteredSessions;
    if (this.isAllExportSelected) {
      visible.forEach((s) => this.exportSelectedIds.delete(s.id));
    } else {
      visible.forEach((s) => this.exportSelectedIds.add(s.id));
    }
  }

  onExportSortChange(order: 'asc' | 'desc'): void {
    this.exportSortOrder = order;
  }

  // Build a human-readable text representation of a single chat session
  private buildChatExportText(session: ChatSession): string {
    const lines: string[] = [];
    const title = this.sanitizeTitle(session.name || session.title) || 'Untitled Chat';
    lines.push(title);
    lines.push('='.repeat(title.length));
    lines.push(`Date: ${session.timestamp ? new Date(session.timestamp).toLocaleString() : 'Unknown'}`);
    if (session.model) lines.push(`Model: ${session.model}`);
    lines.push('');

    const history = session.history || [];
    if (history.length === 0) {
      lines.push('(No messages in this chat.)');
    }

    history.forEach((msg) => {
      const role = msg.type === 'user' ? 'You' : 'Assistant';
      const stamp = msg.date ? ` [${new Date(msg.date).toLocaleString()}]` : '';
      lines.push(`${role}${stamp}:`);
      lines.push(this.decodeHtmlEntities(msg.content || '').trim());
      lines.push('');
    });

    return lines.join('\n');
  }

  // Produce a filesystem-safe file name for a chat
  private safeFileName(name: string, fallback: string): string {
    const cleaned = (name || '')
      .replace(/[\\/:*?"<>|]+/g, '') // strip illegal filename chars
      .replace(/\s+/g, '_')
      .trim();
    return (cleaned || fallback).substring(0, 80);
  }

  // Fetch full history for selected chats and download them as a single ZIP
  exportSelectedChats(): void {
    const selected = this.exportFilteredSessions.filter((s) => this.exportSelectedIds.has(s.id));
    if (selected.length === 0) {
      Swal.fire({ icon: 'info', title: 'No chats selected', text: 'Please select at least one chat to export.' });
      return;
    }

    this.isExporting = true;

    // Fetch each selected session's full data (with history). Errors per-session
    // are swallowed so one failure doesn't abort the whole export.
    const requests = selected.map((s) =>
      this.chatSessionService.fetchSessionDataById(s.id).pipe(
        catchError(() => of(null)),
      )
    );

    forkJoin(requests).subscribe({
      next: async (results) => {
        try {
          const zip = new JSZip();
          const usedNames = new Set<string>();

          results.forEach((fetched, index) => {
            // Fall back to the metadata-only session if the full fetch failed
            const meta = selected[index];
            const session: ChatSession = (fetched as ChatSession) || meta;

            const baseName = this.safeFileName(
              this.sanitizeTitle(session.name || session.title),
              `chat_${index + 1}`
            );
            // Ensure unique file names inside the zip
            let fileName = `${baseName}.txt`;
            let counter = 1;
            while (usedNames.has(fileName)) {
              fileName = `${baseName}_${counter++}.txt`;
            }
            usedNames.add(fileName);

            zip.file(fileName, this.buildChatExportText(session));
          });

          const blob = await zip.generateAsync({ type: 'blob' });
          const stamp = new Date().toISOString().slice(0, 10);
          this.triggerDownload(blob, `chat-export-${stamp}.zip`);

          this.isExporting = false;
          this.isExportModalOpen = false;
          this.cdr.detectChanges();
        } catch (err) {
          console.error('Error generating ZIP:', err);
          this.isExporting = false;
          this.cdr.detectChanges();
          Swal.fire({ icon: 'error', title: 'Export failed', text: 'Something went wrong while creating the ZIP file.' });
        }
      },
      error: (err) => {
        console.error('Error fetching chats for export:', err);
        this.isExporting = false;
        this.cdr.detectChanges();
        Swal.fire({ icon: 'error', title: 'Export failed', text: 'Could not load the selected chats. Please try again.' });
      },
    });
  }

  // Trigger a browser download for a generated Blob
  private triggerDownload(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    // Close dropdowns when clicking outside
    const target = event.target as HTMLElement;
    if (!target.closest('.user-profile-wrapper') && !target.closest('.notification-wrapper') && !target.closest('.font-size-wrapper')) {
      this.isUserDropdownOpen = false;
      this.isNotificationDropdownOpen = false;
      this.isFontSizeDropdownOpen = false;
    }
  }

  logout(): void {
    this.msalService.logout();
  }

  onMouseDown(event: MouseEvent): void {
    this.isDragging = true;
    this.initialMouseX = event.clientX;
    this.initialSidebarWidth = this.sidebarWidth;
    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
    event.preventDefault();
  }

  saveChatSessions(): void {
    // Ensure userId is available. Generate if not, or get from localStorage.
    const currentUserId = localStorage.getItem("userId");
    if (!currentUserId) {
      console.error(
        "Cannot save session: User ID not found in localStorage. Please ensure userId is generated on app start."
      );
      this.messageService.showUserIdNotFound('save');
      return;
    }

    if (this.chatSessions.length === 0) {
      console.log("No chat sessions to save.");
      return;
    }

    const currentSession = this.chatSessions.find(
      (s) => s.id === this.currentSessionId
    );
    if (!currentSession) {
      console.warn("No current session found to save to API.");
      return;
    }

    // Strip large base64 file data from history before saving to backend
    const sanitizedHistory = currentSession.history.map((msg: ChatMessage) => {
      const sanitizedMsg = { ...msg };
      const fileArray = this.getSafeFileArray(sanitizedMsg.file);
      if (fileArray.length > 0) {
        // Keep only file metadata, remove base64 content
        sanitizedMsg.file = fileArray.map((f: any) => ({
          name: f.name,
          type: f.type,
          size: f.size,
          // Exclude base64, preview, and img to reduce payload size
        }));
      } else {
        sanitizedMsg.file = [];
      }
      return sanitizedMsg;
    });

    const payload = {
      action: "save", // This might be an action for a generic endpoint, ensure your backend handles it.
      id: currentSession.id,
      name: currentSession.name || "new chat",
      temperature: currentSession.temperature,
      model: this.selectdModel,
      timestamp: currentSession.timestamp,
      history: sanitizedHistory, // Use sanitized history without large file data
      userId: currentUserId, // Use the consistent userId
      db_name: environment.dbName,
    };

    console.log("Payload to API:", payload);

    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    this.http.post(`${environment.apiBaseUrl}/sessions`, payload, { headers }).subscribe({
      next: (response) => {
        console.log("✅ Sessions successfully saved to API.");
        this.sideContainer.fetchdata();
      },
      error: (error) => {
        console.error("❌ Error saving sessions to API:", error);
        this.messageService.showSessionSaveError();
      }
    });
  }

  private generateSessionId(): string {
    return (
      "session-" +
      Date.now().toString(36) +
      Math.random().toString(36).substr(2, 9)
    );
  }

  zoomIn(): void {
    const oldZoom = this.zoomLevel;
    this.zoomLevel = Math.min(this.zoomLevel + 0.1, 2.0);
    if (this.zoomLevel !== oldZoom) {
      this.applyZoom();
      this.showZoomFeedback(`${Math.round(this.zoomLevel * 100)}%`);
    }
  }

  zoomOut(): void {
    const oldZoom = this.zoomLevel;
    this.zoomLevel = Math.max(this.zoomLevel - 0.1, 0.5);
    if (this.zoomLevel !== oldZoom) {
      this.applyZoom();
      this.showZoomFeedback(`${Math.round(this.zoomLevel * 100)}%`);
    }
  }

  resetZoom(): void {
    this.zoomLevel = 1.0;
    this.applyZoom();
    this.showZoomFeedback("100% (Reset)");
  }

  private showZoomFeedback(message: string): void {
    // Create a temporary zoom feedback element
    const feedback = document.createElement("div");
    feedback.textContent = `Zoom: ${message}`;
    feedback.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 500;
      z-index: 10000;
      pointer-events: none;
      transition: opacity 0.3s ease;
    `;

    document.body.appendChild(feedback);

    // Fade out and remove
    setTimeout(() => {
      feedback.style.opacity = "0";
      setTimeout(() => {
        if (feedback.parentNode) {
          feedback.parentNode.removeChild(feedback);
        }
      }, 300);
    }, 1000);
  }

  private applyZoom(): void {
    // Set CSS custom property for zoom level
    document.documentElement.style.setProperty(
      "--app-zoom-level",
      this.zoomLevel.toString()
    );

    const html = document.documentElement;
    const body = document.body;

    if (html && body) {
      // Clear all zoom/transform from html and body
      html.style.setProperty("zoom", "");
      html.style.fontSize = "";
      body.style.setProperty("zoom", "");
      body.style.transform = "";
      body.style.transformOrigin = "";
      body.style.width = "";
      body.style.height = "";

      // Apply zoom via transform:scale on .app-container.
      // Container is sized at 100/zoom % so scaled result fills viewport exactly.
      const appContainer = document.querySelector('.app-container') as HTMLElement;
      if (appContainer) {
        // Remove any CSS zoom
        appContainer.style.setProperty("zoom", "");
        // Scale the container
        appContainer.style.position = "fixed";
        appContainer.style.left = "0";
        appContainer.style.top = "0";
        appContainer.style.transform = `scale(${this.zoomLevel})`;
        appContainer.style.transformOrigin = "top left";
        // Make container large enough so after scaling it fills the viewport
        const scaledWidth = Math.ceil(window.innerWidth / this.zoomLevel);
        const scaledHeight = Math.ceil(window.innerHeight / this.zoomLevel);
        appContainer.style.setProperty("width", `${scaledWidth}px`, "important");
        appContainer.style.setProperty("height", `${scaledHeight}px`, "important");
        // Clip any overflow from the scaled container at the body level
        body.style.overflow = "hidden";
      }

      // Add zoom class for additional CSS targeting
      body.classList.remove("zoom-small", "zoom-normal", "zoom-large");
      if (this.zoomLevel < 0.9) {
        body.classList.add("zoom-small");
      } else if (this.zoomLevel > 1.1) {
        body.classList.add("zoom-large");
      } else {
        body.classList.add("zoom-normal");
      }
    }

    // Store zoom level in localStorage for persistence
    localStorage.setItem("appZoomLevel", this.zoomLevel.toString());

    // Trigger a resize event to help components adjust
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 100);
  }

  toggleWebSearch(): void {
    this.isWebSearchEnabled = !this.isWebSearchEnabled;
    if (this.selectdModel.includes('gpt')) {
      this.isSearchEnabled = this.isWebSearchEnabled;
    }
    console.log("Web search toggled:", this.isWebSearchEnabled);
  }

  private updateWebSearchState(): void {
    // Default search state: enabled for Gemini models, disabled for GPT models
    this.isWebSearchEnabled = this.selectdModel.includes("gemini");
  }

  private loadSavedZoomLevel(): void {
    const savedZoom = localStorage.getItem("appZoomLevel");
    if (savedZoom) {
      const zoomValue = parseFloat(savedZoom);
      if (zoomValue >= 0.5 && zoomValue <= 2.0) {
        this.zoomLevel = zoomValue;
        this.applyZoom();
      }
    }
  }

  @HostListener("window:resize")
  onWindowResize(): void {
    // Recalculate pixel-based dimensions when window is resized
    const appContainer = document.querySelector('.app-container') as HTMLElement;
    if (appContainer && this.zoomLevel) {
      const h = Math.ceil(window.innerHeight / this.zoomLevel);
      const w = Math.ceil(window.innerWidth / this.zoomLevel);
      appContainer.style.setProperty("width", `${w}px`, "important");
      appContainer.style.setProperty("height", `${h}px`, "important");
    }
  }

  @HostListener("document:keydown", ["$event"])
  handleKeyboardShortcuts(event: KeyboardEvent): void {
    // Zoom shortcuts (Ctrl/Cmd + Plus/Minus/0)
    if ((event.ctrlKey || event.metaKey) && !event.shiftKey && !event.altKey) {
      switch (event.code) {
        case "Equal": // Plus key (without shift)
        case "NumpadAdd":
          event.preventDefault();
          this.zoomIn();
          break;
        case "Minus":
        case "NumpadSubtract":
          event.preventDefault();
          this.zoomOut();
          break;
        case "Digit0":
        case "Numpad0":
          event.preventDefault();
          this.resetZoom();
          break;
      }
    }
  }

  handleNewChat(
    forceNew: boolean = false,
    modelToUse?: string,
    tempToUse?: number
  ): void {
    console.log("🔥 handleNewChat called - Starting new chat process");

    // 🔥 STEP 0: Abort any in-flight Gemini stream immediately
    this.geminiService.abortActiveStream();

    // 🔥 FIRST PRIORITY: Immediately remove/clear the current session
    console.log("🔥 STEP 1: Immediately clearing current session");
    this.currentSessionId = null;
    this.currentSessionName = "New Chat";
    this.chatHistory = [];

    // 🔥 STEP 2: Clear from localStorage immediately
    localStorage.removeItem("currentSessionId");
    console.log("🔥 STEP 2: Cleared currentSessionId from localStorage");

    // 🔥 STEP 3: Clear from service immediately
    this.chatSessionService.setCurrentSession(null);
    console.log("🔥 STEP 3: Cleared current session in service");

    // Use selected model/temp or fallback to defaults
    const model = modelToUse || this.selectdModel || "gpt-4.1";
    const temp =
      tempToUse !== undefined
        ? tempToUse
        : this.selectdTemperature !== undefined
        ? this.selectdTemperature
        : 0.7;

    // Set flag to prevent automatic session restoration
    this.isStartingNewChat = true;
    console.log("🔥 Set isStartingNewChat = true");

    // NUCLEAR OPTION: Block ALL session changes at the service level
    this.chatSessionService.blockNewChatSessionChanges();

    // 🔥 STEP 4: Complete the UI reset
    this.userPrompt = "";
    this.selectedFiles = [];
    this.isTokenLimitExceeded = false;
    // Token count managed by cumulative tracking system
    this.selectdModel = model;
    this.selectdTemperature = temp;
    this.balanced_token = model.startsWith("gemini")
      ? this.gemini_max_token
      : this.gpt_max_token;
    console.log("🔥 STEP 4: Completed UI reset for new chat");

    this.focusTextArea();
    this.cdr.detectChanges();

    // Set multiple timeouts to aggressively maintain new chat state
    setTimeout(() => {
      if (this.isStartingNewChat) {
        console.log("🔥 Maintaining new chat state after 1 second");
        this.currentSessionId = null;
        this.currentSessionName = "New Chat";
        this.chatHistory = [];
        this.chatSessionService.setCurrentSession(null);
      }
    }, 1000);

    setTimeout(() => {
      if (this.isStartingNewChat) {
        console.log("🔥 Maintaining new chat state after 3 seconds");
        this.currentSessionId = null;
        this.currentSessionName = "New Chat";
        this.chatHistory = [];
        this.chatSessionService.setCurrentSession(null);
      }
    }, 3000);

    setTimeout(() => {
      if (this.isStartingNewChat) {
        console.log("🔥 Maintaining new chat state after 5 seconds");
        this.currentSessionId = null;
        this.currentSessionName = "New Chat";
        this.chatHistory = [];
        this.chatSessionService.setCurrentSession(null);
      }
    }, 5000);

    console.log("🔥 New chat prepared, waiting for user interaction");
  }

  loadSession(sessionId: string): void {
    console.log("loadSession: Attempting to load session with ID:", sessionId);
    console.log("loadSession: Attempting to load session with ID:", sessionId);

    // Reset the new chat flag since user is loading an existing session
    this.isStartingNewChat = false;

    // UNBLOCK session changes since user is loading a session
    this.chatSessionService.unblockNewChatSessionChanges();

    const sessionToLoad = this.chatSessions.find(s => s.id === sessionId);
    if (!sessionToLoad) return;

    if (this.currentSessionId && this.currentSessionId !== sessionId) {
      const currentSession = this.chatSessions.find(
        (s) => s.id === this.currentSessionId
      );
      if (currentSession && currentSession.history.length > 0) {
        this.saveCurrentSession();
      } else if (currentSession && currentSession.history.length === 0) {
        this.chatSessions = this.chatSessions.filter(
          (s) => s.id !== this.currentSessionId
        );
        this.saveChatSessions();
      }
    }

    this.currentSessionId = sessionToLoad.id;
    this.chatHistory = this.normalizeHistory(sessionToLoad.history);

    this.currentSessionName = this.sanitizeTitle(sessionToLoad.name);
    this.selectdModel = sessionToLoad.model || this.selectdModel;
    this.selectdTemperature =
      sessionToLoad.temperature || this.selectdTemperature;
    this.userPrompt = "";
    this.selectedFiles = [];

    if (this.selectdModel.startsWith("gemini")) {
      this.balanced_token = this.gemini_max_token;
    } else {
      this.balanced_token = this.gpt_max_token;
    }
    // Token count managed by cumulative tracking system
    this.isTokenLimitExceeded = false;

    // Sync previous selections to match loaded session
    this.previousModel = this.selectdModel;
    this.previousTemperature = this.selectdTemperature;
    this.previousReasoning = this.selectedReasoning;

    // Sync with service
    this.chatSessionService.setCurrentSession(sessionToLoad);
  }

  loadSessionById(sessionId: string): void {
    console.log("Loading session by ID:", sessionId);

    // Reset the new chat flag since user is loading an existing session
    this.isStartingNewChat = false;

    // UNBLOCK session changes since user is loading a session
    this.chatSessionService.unblockNewChatSessionChanges();

    // Optimize: check if session is already loaded in memory with history
    const session = this.chatSessions.find(s => s.id === sessionId);
    if (session && session.history && session.history.length > 0) {
      console.log("Found session with history in memory:", session);
      this.currentSessionId = session.id;
      this.currentSessionName = this.sanitizeTitle(session.name);
      this.chatHistory = session.history.map((msg) => ({
        ...msg,
        content: this.decodeHtmlEntities(msg.content),
        references: msg.references || [],
      }));
      this.selectdModel = session.model || this.selectdModel;
      this.selectdTemperature = session.temperature ?? this.selectdTemperature;
      
      this.restoreSessionTokens(session.id);
      this.isTokenLimitExceeded = false;
      this.chatSessionService.setCurrentSession(session);

      // Staged rendering to ensure all messages display
      this.cdr.detectChanges();
      setTimeout(() => {
        this.cdr.detectChanges();
        this.scrollToStartOfLastAssistantMessage();
        this.focusTextArea();
      }, 150);
      setTimeout(() => {
        this.cdr.detectChanges();
      }, 500);
      return;
    }

    // Fallback: Use service's HttpClient-based method instead of raw native fetch()
    const userId = localStorage.getItem("userId");
    if (!userId) {
      this.messageService.showUserIdNotFound('save');
      return;
    }
    this.chatSessionService.fetchSessionByIdFromApi(sessionId, userId).subscribe({
      next: (fullSession) => {
        // Directly read the current session from the service to ensure chatHistory is set
        // regardless of the currentSession$ subscription timing
        this.zone.run(() => {
          const currentSession = this.chatSessionService.getCurrentSession();
          if (currentSession && currentSession.id === sessionId) {
            this.currentSessionId = currentSession.id;
            this.currentSessionName = this.sanitizeTitle(currentSession.name);
            this.chatHistory = (currentSession.history || []).map((msg) => ({
              ...msg,
              content: this.decodeHtmlEntities(msg.content),
              references: msg.references || [],
            }));
            this.selectdModel = currentSession.model || this.selectdModel;
            this.selectdTemperature = currentSession.temperature ?? this.selectdTemperature;
            this.restoreSessionTokens(currentSession.id);
            this.isTokenLimitExceeded = false;
          }
          
          // Force immediate change detection
          this.cdr.detectChanges();
          
          // Stage 1: Allow browser to paint, then detect changes again for markdown rendering
          setTimeout(() => {
            this.cdr.detectChanges();
          }, 0);
          
          // Stage 2: Scroll to position after DOM has fully rendered
          setTimeout(() => {
            this.scrollToStartOfLastAssistantMessage();
            this.focusTextArea();
            this.cdr.detectChanges();
          }, 150);
          
          // Stage 3: Final safety detectChanges for very long conversations
          setTimeout(() => {
            this.cdr.detectChanges();
          }, 500);
        });
      },
      error: (err) => {
        console.error("Error loading session via service:", err);
      }
    });
  }

  handleSessionDeleted(sessionId: string): void {
    console.log("delete trigger ", sessionId);
    const sessionToDelete = this.chatSessions.find((s) => s.id === sessionId);
    const sessionName = sessionToDelete
      ? sessionToDelete.name
      : "this chat session";
    const confirmation = confirm(
      `Are you sure you want to delete "${sessionName}"?`
    );
    if (confirmation) {
      const wasCurrentSession = this.currentSessionId === sessionId;
      this.chatSessions = this.chatSessions.filter((s) => s.id !== sessionId);
      const userId = localStorage.getItem("userId");

      if (!userId) {
        console.error("User ID not found in localStorage.");

        this.messageService.showUserIdNotFound('delete');

        return;
      }
      const nj = { id: sessionId, userId: userId, db_name: environment.dbName };
      const apiUrl = `${environment.apiBaseUrl}/sessions/delete`;
      this.http.post(apiUrl, nj).subscribe({
        next: () => {
          console.log("Session deleted successfully from API.");
        },
        error: (err: any) => {
          console.error("Error deleting session on server:", err);

          this.messageService.showSessionDeleteApiError();
        },
      });
      if (wasCurrentSession) {
        if (this.chatSessions.length > 0) {
          this.loadSession(this.chatSessions[0].id);
        } else {
          // Don't automatically create a new session - let the service handle this
          console.log(
            "No sessions remaining, waiting for service to create new session"
          );
        }
      }
      this.saveChatSessions();
    }
  }

  handleSessionEdited(updatedSession: ChatSession): void {
    const index = this.chatSessions.findIndex(
      (s) => s.id === updatedSession.id
    );
    if (index !== -1) {
      this.chatSessions[index] = updatedSession;
      if (this.currentSessionId === updatedSession.id) {
        this.currentSessionName = this.sanitizeTitle(updatedSession.name);
      }
      this.saveChatSessions();
    }
  }
  // State variables
  showConfirmPopup = false;
  selectedTemperatureName = "";

  // Called when user changes temperature or model
  previousModel = this.selectdModel;
  previousTemperature = this.selectdTemperature;
  previousReasoning = this.selectedReasoning;

  private sanitizeTitle(value: string | null | undefined): string {
    return (value || "").replace(/^["'“”]+|["'“”]+$/g, "");
  }

  private decodeHtmlEntities(text: string): string {
    if (!text) return "";
    if (!text.includes("&")) return text;

    let decoded = text;
    let prev;
    let iterations = 0;

    const entities: { [key: string]: string } = {
      "amp": "&",
      "lt": "<",
      "gt": ">",
      "quot": "\"",
      "apos": "'",
      "#39": "'",
      "#x27": "'",
      "#x2F": "/",
      "#47": "/",
      "#60": "<",
      "#62": ">"
    };

    const decodeOnePass = (str: string): string => {
      return str.replace(/&([^;]+);/g, (match, entity) => {
        if (entities[entity]) {
          return entities[entity];
        }
        if (entity.startsWith("#")) {
          const code = entity.startsWith("#x") 
            ? parseInt(entity.substring(2), 16) 
            : parseInt(entity.substring(1), 10);
          if (!isNaN(code)) {
            return String.fromCharCode(code);
          }
        }
        return match;
      });
    };

    do {
      prev = decoded;
      decoded = decodeOnePass(decoded);
      iterations++;
    } while (decoded !== prev && iterations < 5);

    return decoded;
  }

  private getSafeFileArray(file: any): any[] {
    if (!file) return [];
    if (Array.isArray(file)) return file;
    if (typeof file === "string") {
      try {
        const parsed = JSON.parse(file);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {}
    }
    return [];
  }

  private persistCurrentSessionTemperature(temp: number): void {
    try {
      if (!this.currentSessionId) return;
      const sessionIndex = this.chatSessions.findIndex(
        (s) => s.id === this.currentSessionId
      );
      if (sessionIndex === -1) return;
      const updatedSession = {
        ...this.chatSessions[sessionIndex],
        temperature: temp,
      };
      this.chatSessions[sessionIndex] = updatedSession;
      this.chatSessionService.updateSession(updatedSession);
    } catch (e) {
      console.warn("Failed to persist session temperature:", e);
    }
  }

  // Handlers for sidebar model/creativity changes
  onSidebarModelChange(model: string): void {
    this.selectdModel = model;
    this.handleModelOrTemperatureChange();
  }

  onSidebarCreativityChange(value: number): void {
    this.selectdTemperature = value;
    this.handleModelOrTemperatureChange();
  }

  onSidebarReasoningChange(reasoning: string): void {
    this.selectedReasoning = reasoning;
    this.handleModelOrTemperatureChange();
  }

  onImageSizeChange(size: string): void {
    this.imageSize = size;
  }

  onImageQualityChange(quality: string): void {
    this.imageQuality = quality;
  }

  onImageStyleChange(style: string): void {
    this.imageStyle = style;
  }

  downloadImage(imageUrl: string): void {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = `generated-image-${Date.now()}.png`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  handleModelOrTemperatureChange(): void {
    const isGpt5MiniModel = this.selectdModel === "gpt-5-mini";
    const selectedTempNum = Number(this.selectdTemperature);

    // Get the creativity level name
    const creativityLevel = isGpt5MiniModel
      ? (this.reasoningLevels.find((t) => t.slug === this.selectedReasoning)?.name || "Medium")
      : (this.temperature.find((t) => t.slug === selectedTempNum)?.name || "Unknown");

    // Get the model name
    const modelName =
      this.models.find((m) => m.slug === this.selectdModel)?.name ||
      "Unknown Model";

    // Detect what changed
    const modelChanged = this.selectdModel !== this.previousModel;
    
    // If model changed and it's an image model, reset image size to default
    if (modelChanged && this.isImageModelSelected) {
      this.imageSize = '1024x1024'; // Reset to square (supported by all)
    }
    const tempChanged = !isGpt5MiniModel && selectedTempNum !== this.previousTemperature;
    const reasoningChanged = isGpt5MiniModel && this.selectedReasoning !== this.previousReasoning;

    // If no actual changes, do nothing
    if (!modelChanged && !tempChanged && !reasoningChanged) {
      return;
    }

    // If we're on a new page/new chat with no history, apply changes silently (no popup)
    const isNewContext =
      (!this.currentSessionId && (!this.chatHistory || this.chatHistory.length === 0)) ||
      (this.currentSessionName === "New Chat" && (!this.chatHistory || this.chatHistory.length === 0)) ||
      this.isStartingNewChat === true;

    if (isNewContext) {
      // For a brand-new chat: apply silently; DO NOT popup; only start new chat if model changed (which is harmless here)
      this.isSearchEnabled = this.selectdModel.startsWith("gemini");
      this.balanced_token = this.selectdModel.startsWith("gemini") ? this.gemini_max_token : this.gpt_max_token;
      this.isTokenLimitExceeded = false;

      // If only creativity/reasoning changed, just record and return
      if (!modelChanged && (tempChanged || reasoningChanged)) {
        if (isGpt5MiniModel) {
          this.previousReasoning = this.selectedReasoning;
        } else {
          this.previousTemperature = selectedTempNum;
          // For an existing created session in "new" state, try to persist locally if available
          this.persistCurrentSessionTemperature(selectedTempNum);
        }
        return;
      }

      // If model changed on a new chat
      if (modelChanged) {
        // Show GPT-5-mini message even in new context
        if (isGpt5MiniModel) {
          this.messageService.showGPT5MiniInfo(modelName);
        }
        
        this.handleNewChat(true, this.selectdModel, selectedTempNum);
        this.previousModel = this.selectdModel;
        if (isGpt5MiniModel) {
          this.previousReasoning = this.selectedReasoning;
        } else {
          this.previousTemperature = selectedTempNum;
          this.persistCurrentSessionTemperature(selectedTempNum);
        }
        return;
      }
    }

    // Existing chat: if only creativity/reasoning changed → apply silently (no popup, no new chat)
    if (!modelChanged && (tempChanged || reasoningChanged)) {
      if (isGpt5MiniModel) {
        this.previousReasoning = this.selectedReasoning;
      } else {
        this.previousTemperature = selectedTempNum;
        // Persist the updated temperature to the current session so the dropdown doesn't revert
        this.persistCurrentSessionTemperature(selectedTempNum);
      }
      // No popup and do NOT start new chat; the next response will use updated level
      return;
    }

    let message = "";
    const isGpt5Mini = isGpt5MiniModel;

    // Existing chat: model change (with or without creativity/reasoning change) → show popup
    if (modelChanged) {
      if (isGpt5Mini) {
        message = `
          <p>Would you like to switch the model to '<strong>${modelName}</strong>'?</p>
          <p style="margin-top:10px; font-size:0.9em; color:#666;">
          Changing inputs will start a new chat session.<br>
          GPT-5 Mini uses reasoning, which means responses may take longer than other chat models.
          </p>
        `;
      } else {
        message = `
          <p>Would you like to switch the model to '<strong>${modelName}</strong>'?</p>
          <p style="margin-top:10px; font-size:0.9em; color:#666;">
            Changing inputs will start a new chat session.
          </p>
        `;
      }
    } else {
      return;
    }

    // SweetAlert confirmation
    this.messageService.showModelSwitchConfirmation(modelName, isGpt5Mini, true).then((result) => {
      if (!result.isConfirmed) {
        // 🔙 Revert selections if user cancels (both model and level)
        this.selectdModel = this.previousModel;
        if (this.previousModel === "gpt-5-mini") {
          this.selectedReasoning = this.previousReasoning;
        } else {
        this.selectdTemperature = this.previousTemperature;
        }
        return;
      }

      // ✅ Apply changes for model switch
      this.isSearchEnabled = this.selectdModel.startsWith("gemini");

      this.balanced_token = this.selectdModel.startsWith("gemini")
        ? this.gemini_max_token
        : this.gpt_max_token;

      // Token count managed by cumulative tracking system
      this.isTokenLimitExceeded = false;

      this.handleNewChat(true, this.selectdModel, selectedTempNum);

      // Save new state
      this.previousModel = this.selectdModel;
      if (isGpt5MiniModel) {
        this.previousReasoning = this.selectedReasoning;
      } else {
      this.previousTemperature = selectedTempNum;
      }

      // No additional toast needed
    });
  }

  // Close popup without action
  closePopup() {
    this.showConfirmPopup = false;
  }

  // Cancel button
  onCancelPopup() {
    this.showConfirmPopup = false;
  }

  // OK button
  onConfirmPopup() {
    this.showConfirmPopup = false;

    // Token logic
    this.balanced_token = this.selectdModel.startsWith("gemini")
      ? this.gemini_max_token
      : this.gpt_max_token;

    // Token count managed by cumulative tracking system
    this.isTokenLimitExceeded = false;

    this.updateWebSearchState();
    this.handleNewChat(true, this.selectdModel, this.selectdTemperature);
  }

   toggleVoiceInput(): void {
    if (!this.speechRecognitionSupported) {
      this.messageService.showVoiceNotSupported();
      return;
    }

    if (this.isRecording) {
      this.stopRecording();
    } else {
      this.startRecording();
    }
  }

  startRecording(): void {
    try {
      // Preserve any existing text so new speech appends instead of clearing
      this.initialPromptBeforeRecording = this.userPrompt || "";
      // Reflect UI state immediately to avoid visual lag
      this.isRecording = true;
      this.recognition.start();
      
      // Track voice input start
      this.appInsightsService.trackEvent('VoiceInputStarted', {
        timestamp: new Date().toISOString()
      });
    } catch (error) {
      console.error('Error starting speech recognition:', error);
      this.isRecording = false;
    }
  }

  stopRecording(): void {
    if (this.recognition) {
      // Reflect UI state immediately to avoid visual lag
      this.isRecording = false;
      this.recognition.stop();
      
      // Track voice input stop
      this.appInsightsService.trackEvent('VoiceInputStopped', {
        timestamp: new Date().toISOString(),
        transcriptLength: this.userPrompt.length
      });
    }
  }

  private initializeSpeechRecognition(): void {
    // Check for speech recognition support
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    
    if (SpeechRecognition) {
      this.speechRecognitionSupported = true;
      this.recognition = new SpeechRecognition();
      
      // Configure recognition settings
      this.recognition.continuous = true; // keep single utterance to avoid run-on capture
      this.recognition.interimResults = true; // stream partials for lower perceived latency
      this.recognition.lang = 'en-US';
      
      // Handle recognition results (with interim partials and final formatting)
      this.recognition.onresult = (event: any) => {
        this.zone.run(() => {
        let finalTranscript = '';
        let interimTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const result = event.results[i];
          const text = result[0]?.transcript || '';
          if (result.isFinal) {
            finalTranscript += text + ' ';
          } else {
            interimTranscript += text;
          }
        }

        if (finalTranscript.trim()) {
            const formatted = this.applySpeechFormatting(
              this.convertSpokenPunctuation(finalTranscript.trim(), true)
            );
            this.userPrompt = (this.initialPromptBeforeRecording || '').replace(/\s+$/, '') + (this.initialPromptBeforeRecording ? ' ' : '') + formatted;
          // Track successful voice input (formatted)
          this.appInsightsService.trackEvent('VoiceInputSuccess', {
            transcriptLength: formatted.length,
            timestamp: new Date().toISOString()
          });
        } else {
          // Update UI with interim partials for responsiveness
            const live = this.convertSpokenPunctuation(interimTranscript, false);
            this.userPrompt = (this.initialPromptBeforeRecording || '').replace(/\s+$/, '') + (this.initialPromptBeforeRecording ? ' ' : '') + live;
        }
          this.cdr.detectChanges();
        });
      };
      
      // Handle recognition errors
      this.recognition.onerror = (event: any) => {
        console.error('Speech recognition error:', event.error);
        this.isRecording = false;
        
        // Track voice input error
        this.appInsightsService.trackEvent('VoiceInputError', {
          error: event.error,
          timestamp: new Date().toISOString()
        });
        
        // Show user-friendly error message
        this.messageService.showVoiceRecognitionError(event.error);
      };
      
      // Handle recognition end
      // this.recognition.onend = () => {
      //   this.isRecording = false;
      //   // Finalize punctuation if user stopped while we only had interim text
      //   const t = (this.userPrompt || '').trim();
      //   if (t && !/[.!?]$/.test(t)) {
      //     this.userPrompt = this.applySpeechFormatting(this.convertSpokenPunctuation(t, true));
      //   }
      //   this.initialPromptBeforeRecording = '';
      //   this.cdr.detectChanges();
      // };
      
      console.log('Speech recognition initialized successfully');
    } else {
      this.speechRecognitionSupported = false;
      console.log('Speech recognition not supported in this browser');
    }
  }

  private applySpeechFormatting(text: string): string {
    try {
      let t = (text || '').trim();
      if (!t) return '';
      // Capitalize first alphabetical character
      const firstAlphaIndex = t.search(/[A-Za-z]/);
      if (firstAlphaIndex >= 0) {
        t =
          t.slice(0, firstAlphaIndex) +
          t.charAt(firstAlphaIndex).toUpperCase() +
          t.slice(firstAlphaIndex + 1);
      }
      // Add trailing punctuation if missing
      if (!/[.!?]$/.test(t)) {
        const lower = t.toLowerCase();
        const likelyQuestion = /^(who|what|when|where|why|how|is|are|am|do|does|did|can|could|would|should|will|were|was|may|might|have|has|had)\b/.test(lower);
        t += likelyQuestion ? '?' : '.';
      }
      return t;
    } catch {
      return text;
    }
  }

  private convertSpokenPunctuation(text: string, isFinal: boolean): string {
    try {
      let t = text || '';
      // Basic punctuation terms
      const map: Array<{ r: RegExp; v: string }> = [
        { r: /\bquestion mark\b/gi, v: '?' },
        { r: /\bexclamation (point|mark)\b/gi, v: '!' },
        { r: /\bperiod\b/gi, v: '.' },
        { r: /\bcomma\b/gi, v: ',' },
        { r: /\bcolon\b/gi, v: ':' },
        { r: /\bsemicolon\b/gi, v: ';' },
        { r: /\bdash\b/gi, v: '-' },
        { r: /\bellipsis\b/gi, v: '…' }
      ];
      for (const m of map) {
        t = t.replace(m.r, m.v);
      }
      // Collapse spaces around punctuation
      t = t.replace(/\s+([?!.,:;…])/g, '$1').replace(/([?!.,:;…])\s+/g, '$1 ');
      // Avoid trailing punctuation spam for interim
      if (!isFinal) {
        t = t.replace(/[?!.,:;…]+$/g, '');
      }
      return t;
    } catch {
      return text;
    }
  }

  private saveCurrentSession(): void {
    if (this.currentSessionId) {
      const sessionIndex = this.chatSessions.findIndex(
        (s) => s.id === this.currentSessionId
      );
      if (sessionIndex !== -1) {
        const currentSession = this.chatSessions[sessionIndex];
        if (this.chatHistory.length > 0 || currentSession.history.length > 0) {
          currentSession.history = [...this.chatHistory];
          currentSession.timestamp = new Date().toISOString();
          currentSession.model = this.selectdModel;
          currentSession.temperature = this.selectdTemperature;
          this.saveChatSessions();
        } else {
          if (
            this.chatSessions.length > 1 ||
            (this.chatSessions.length === 1 &&
              currentSession.name === "New Chat" &&
              currentSession.history.length === 0)
          ) {
            this.chatSessions = this.chatSessions.filter(
              (s) => s.id !== this.currentSessionId
            );
            this.saveChatSessions();
          }
        }
      }
    }
  }

  async generateImage(): Promise<void> {
    if (!this.userPrompt.trim()) return;

    const prompt = this.userPrompt.trim();
    const currentDate = moment().tz("America/New_York").format("lll");

    // Reset the new chat flag since user is now interacting
    this.isStartingNewChat = false;

    // UNBLOCK session changes since user is now actually interacting
    this.chatSessionService.unblockNewChatSessionChanges();

    // Create a session if none exists (first interaction)
    if (!this.currentSessionId) {
      const newSession =
        this.chatSessionService.createSessionOnFirstInteraction(
          this.selectdModel,
          this.selectdTemperature
        );
      this.currentSessionId = newSession.id;
      this.currentSessionName = newSession.name;
      this.chatHistory = [];
    }

    // Add user message
    const userMessage: ChatMessage = {
      type: "user",
      content: prompt,
      date: currentDate,
      file: [],
    };
    this.chatHistory.push(userMessage);

    // Add placeholder for AI response
    const aiMessage: ChatMessage = {
      type: "model",
      content: "Generating image...",
      date: currentDate,
      imageUrl: undefined,
    };
    this.chatHistory.push(aiMessage);

    this.userPrompt = "";
    this.isLoading = true;
    this.shouldAutoScroll = true;
    this.scrollToBottom();

    try {
      // Pass the selected model to the service
      const imageUrl = await this.imageGenerationService.generateImage(
        prompt,
        this.imageSize,
        this.imageQuality,
        this.imageStyle,
        this.selectdModel  // Pass the model name
      );

      // Update the AI message with the generated image
      aiMessage.content = `Here's your generated image:`;
      aiMessage.imageUrl = imageUrl;

      this.updateCurrentSessionHistory();
      this.scrollToBottom();
    } catch (error: any) {
      console.error("Image generation error:", error);
      
      // Update message with error
      aiMessage.content = `Sorry, I couldn't generate the image. ${error.message || 'Please try again.'}`;
      
      this.messageService.showImageGenerationError(error.message);
    } finally {
      this.isLoading = false;
      this.focusTextArea();
    }
  }

  clearChatHistory(): void {
    if (this.currentSessionId) {
      const currentSession = this.chatSessions.find(
        (s) => s.id === this.currentSessionId
      );
      if (currentSession && currentSession.history.length > 0) {
        this.saveCurrentSession();
      } else if (currentSession && currentSession.history.length === 0) {
        if (this.chatSessions.length > 1) {
          this.chatSessions = this.chatSessions.filter(
            (s) => s.id !== this.currentSessionId
          );
          this.saveChatSessions();
        }
      }
    }

    this.chatHistory = [];
    this.userPrompt = "";
    this.selectedFiles = [];
    this.triggerClearAllElement();

    if (this.selectdModel.startsWith("gemini")) {
      this.balanced_token = this.gemini_max_token;
    } else {
      this.balanced_token = this.gpt_max_token;
    }
    // Token count managed by cumulative tracking system
    this.isPopoverOpen = false;
    this.myTextArea?.nativeElement.focus();

    // Don't automatically create a new session - let the service handle this
    console.log(
      "Chat history cleared, waiting for user to create new chat if needed"
    );
  }

  setCurrentSession(session: ChatSession): void {
    this.currentSessionId = session.id;
    this.currentSessionName = this.sanitizeTitle(session.name);
    this.chatHistory = this.normalizeHistory(session.history);
    this.selectdModel = session.model || this.selectdModel;
    this.selectdTemperature = session.temperature || this.selectdTemperature;

    if (this.selectdModel.startsWith("gemini")) {
      this.balanced_token = this.gemini_max_token;
    } else {
      this.balanced_token = this.gpt_max_token;
    }
    // Token count managed by cumulative tracking system
    this.isTokenLimitExceeded = false;
  }

  copyMessage(content: string): void {
    // Decode any HTML entities so the copied text matches what is rendered.
    navigator.clipboard.writeText(this.decodeHtmlEntities(content)).then(() => {
      this.copiedMessageIndex = this.chatHistory.find(c => c.content === content);
      setTimeout(() => {
        this.copiedMessageIndex = null;
      }, 2000);
    });
  }
}
